
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ZoEg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ecebc87fc43a7362$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");

var $exb0h = parcelRequire("exb0h");

var $fWkFY = parcelRequire("fWkFY");

var $kEBPk = parcelRequire("kEBPk");

var $3Dnr1 = parcelRequire("3Dnr1");
var $jOV2f = parcelRequire("jOV2f");
var $lIqKj = parcelRequire("lIqKj");
var $244wN = parcelRequire("244wN");
var $yhxNs = parcelRequire("yhxNs");
var $hOodT = parcelRequire("hOodT");
var $aIeBA = parcelRequire("aIeBA");
var $f9MgH = parcelRequire("f9MgH");

var $bEZRh = parcelRequire("bEZRh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $kJlBc = parcelRequire("kJlBc");

var $jK1pm = parcelRequire("jK1pm");

var $9wImn = parcelRequire("9wImn");

var $aNvoT = parcelRequire("aNvoT");

var $hg1IN = parcelRequire("hg1IN");

var $cnaIA = parcelRequire("cnaIA");

var $5jNIh = parcelRequire("5jNIh");

var $Ymajv = parcelRequire("Ymajv");
var $ecebc87fc43a7362$export$2e2bcd8739ae039 = ()=>{
    const { data: dashboards, error: error, loading: loading, currentDashboardIndex: currentDashboardIndex } = (0, $9wImn.useDashboardsWallboardSlideShow)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { path: viewPath } = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES).DASHBOARD_VIEW) ?? {};
    const onQuittingWallboard = (0, $eUqFw.useCallback)(()=>viewPath && dashboards && dashboards[currentDashboardIndex] && dashboards[currentDashboardIndex].id && push((0, $kJlBc.generatePath)(viewPath, {
            dashboardId: dashboards[currentDashboardIndex].id
        })), [
        push,
        dashboards,
        currentDashboardIndex,
        viewPath
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { registerConnectGadget: registerConnectGadget, unregisterConnectGadget: unregisterConnectGadget } = (0, $f9MgH.useConnectGadgetTitles)();
    if (false || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yhxNs.GenericLoadingView), null);
    if (dashboards == null || error != null) // here we re-use single dashboard's DashboardContentContainer to display error view and fire analytics events
    // TODO this still won't handle empty dashboards array. It will still display a blank page.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dnr1.DashboardContentContainer), {
        analyticsExperience: (0, $kEBPk.VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE),
        resourceData: {
            data: null,
            error: error,
            loading: loading
        },
        permissionErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.WallboardPermissionErrorPageAsync), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ecebc87fc43a7362$var$WallboardPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ecebc87fc43a7362$var$WallboardSlideShowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "dashboard-wallboard"
    }, dashboards && !false && dashboards.map((data, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ecebc87fc43a7362$var$SingleWallboardWrapper, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $244wN.DashboardPageContainer), {
            analyticsSourceName: (0, $kEBPk.DASHBOARD_WALLBOARD_VIEW_SOURCENAME),
            analyticsExperience: (0, $kEBPk.VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE),
            documentTitle: data?.title ?? formatMessage((0, $5jNIh.default).pageTitle),
            unauthenticatedFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null),
            resourceData: {
                data: data,
                error: error,
                loading: loading
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dnr1.DashboardContentContainer), {
            analyticsExperience: (0, $kEBPk.VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE),
            resourceData: {
                data: data,
                error: error,
                loading: loading
            },
            permissionErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.WallboardPermissionErrorPageAsync), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnaIA.default), {
            onPressedEsc: onQuittingWallboard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ecebc87fc43a7362$var$WallboardContentWrapper, {
            isHidden: currentDashboardIndex !== index
        }, data && data.layout && data.gadgets ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOV2f.DashboardController), {
            id: data.id,
            automaticRefreshMs: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
            layout: "fluid"
        }, (0, $aIeBA.toColumns)(data.gadgets, data.layout).map((columnGadgets, columnIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aNvoT.WallboardColumn), {
                key: columnIndex,
                gadgets: columnGadgets,
                columnWidth: (0, $hOodT.getColumnWidth)(columnIndex, data.layout, (0, $kEBPk.GADGET_DISPLAY).NORMAL),
                dashboardId: data.id
            }, ({ gadget: gadget })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIqKj.DashboardControllerContextConsumer), null, ({ refreshId: refreshId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hg1IN.WallboardGadget), {
                        gadget: gadget,
                        dashboardId: data.id,
                        refreshId: refreshId,
                        unconfiguredFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Ymajv.UnconfiguredGadgetWallboardFallback), {
                            id: gadget.id
                        }),
                        onRegisterConnectGadget: registerConnectGadget,
                        onUnregisterConnectGadget: unregisterConnectGadget
                    })))))) : null))))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ecebc87fc43a7362$var$WallboardPageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ecebc87fc43a7362$var$WallboardSlideShowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _yv0ehkll _ca0qv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ecebc87fc43a7362$var$SingleWallboardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p3z3kb7n _1461kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $ecebc87fc43a7362$var$WallboardContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHidden ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    window.location.assign(url);
    return null;
};

});


parcelRegister("3Dnr1", function(module, exports) {

$parcel$export(module.exports, "DashboardContentContainer", () => $df896dcfcfa5fd49$export$b49692a976fb3d05);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $kwMhr = parcelRequire("kwMhr");

var $gUUjF = parcelRequire("gUUjF");

var $bEZRh = parcelRequire("bEZRh");


var $01Qi5 = parcelRequire("01Qi5");

var $yhxNs = parcelRequire("yhxNs");

var $2on8Z = parcelRequire("2on8Z");

var $dYru8 = parcelRequire("dYru8");

var $6QUMT = parcelRequire("6QUMT");

var $4UDpw = parcelRequire("4UDpw");

var $9zcCd = parcelRequire("9zcCd");

var $1xFgW = parcelRequire("1xFgW");

var $kVRTc = parcelRequire("kVRTc");

var $4Jf8r = parcelRequire("4Jf8r");

var $3kpkG = parcelRequire("3kpkG");

var $35TBS = parcelRequire("35TBS");

var $b4XFG = parcelRequire("b4XFG");
const $df896dcfcfa5fd49$var$HALF_HOUR = 1800000;
const $df896dcfcfa5fd49$export$d3a4cb300c572c66 = ({ data: { id: id, gadgets: gadgets, layout: layout }, saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    (0, $9zcCd.useSpaStatePageReady)();
    (0, $35TBS.usePageStatusLogger)($df896dcfcfa5fd49$var$HALF_HOUR);
    (0, $4UDpw.useGadgetMetricsBridge)(id, gadgets, layout);
    (0, $2on8Z.useConnectApi)({
        saveCustomGadgetTitle: saveCustomGadgetTitle
    });
    return null;
};
const $df896dcfcfa5fd49$var$AMD_RESOURCE_RETRY_LIMIT = 2;
const $df896dcfcfa5fd49$export$b49692a976fb3d05 = ({ children: children, customHeight: customHeight, analyticsExperience: analyticsExperience, saveCustomGadgetTitle: saveCustomGadgetTitle = ()=>Promise.resolve(), resourceData: resourceData, permissionErrorFallback: permissionErrorFallback })=>{
    const { data: configData, error: configError, loading: configLoading } = resourceData;
    const { loading: amdLoading, data: amdData, error: amdError, refresh: amdRefresh } = (0, $01Qi5.useDashboardAMDModulesResource)();
    const [amdResourceRetries, setAmdResourceRetries] = (0, $eUqFw.useState)(0);
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const eventSent = (0, $eUqFw.useRef)(null);
    const isAmdResourceUnhealthy = configData != null && amdData == null && amdError != null || amdData?.amdModules != null && Object.values(amdData?.amdModules).some((v)=>v == null);
    const isAmdResourceRetriesExceeded = !amdLoading && amdResourceRetries >= $df896dcfcfa5fd49$var$AMD_RESOURCE_RETRY_LIMIT;
    (0, $eUqFw.useEffect)(()=>{
        if (false || configLoading || configData == null || eventSent.current === Number(configData.id)) return;
        fireAnalytics({
            eventType: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
            actionSubjectId: 'dashboard',
            actionSubject: 'dashboardScreen',
            action: 'viewed'
        });
        (0, $1xFgW.addDashboardToRecents)(configData.id);
        eventSent.current = Number(configData.id);
    }, [
        configData,
        fireAnalytics,
        configLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (false) return;
        if (amdLoading) {
            // NOTE - reset retries when resource changes
            !isAmdResourceUnhealthy && setAmdResourceRetries(0);
            return;
        }
        if (!isAmdResourceUnhealthy) (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.content-container', `AMD resource loaded, after retries [${amdResourceRetries}]`);
        else if (isAmdResourceRetriesExceeded) {
            const [failedCount, totalCount] = Object.values(amdData?.amdModules ?? []).reduce(([f], v, i, arr)=>[
                    f + (v == null ? 1 : 0),
                    arr.length
                ], [
                0,
                0
            ]);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.content-container', amdError ? `AMD resource error [${String(amdError.message)}]` : `AMD resource degraded, failed [${failedCount}] of [${totalCount}] gadgets`);
        } else {
            (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.content-container', `Retrying AMD resource, retry [${amdResourceRetries + 1}]`);
            setAmdResourceRetries((n)=>n + 1);
            amdRefresh();
        }
    }, [
        amdResourceRetries,
        amdLoading,
        amdError,
        amdData,
        isAmdResourceUnhealthy,
        isAmdResourceRetriesExceeded,
        amdRefresh
    ]);
    if (false || configLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yhxNs.GenericLoadingView), {
        customHeight: customHeight
    });
    if (configError != null || configData == null) {
        const errorCode = Number(configError?.message?.substring(configError.message.length - 3));
        if ((0, $3kpkG.DASHBOARD_PERMISSION_ERROR_CODE_LIST).includes(errorCode)) return permissionErrorFallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: configError ? configError.message : 'unknown error'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), null));
    }
    if (isAmdResourceRetriesExceeded && amdError != null && amdData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
        location: analyticsExperience,
        failureEventAttributes: {
            error: `AMD resource error [${String(amdError.message)}]`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), null));
    return(// ThemeProvider will no longer be used in later versions of Atlaskit Grid
    // Remove when @atlaskit/page is updated
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: analyticsExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Jf8r.AmdGadgetMonolithOverrideStyles), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVRTc.AboveTheFoldContainer), {
        dashboardId: configData.id,
        layout: configData.layout,
        gadgets: configData.gadgets
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6QUMT.GadgetAdditionalStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df896dcfcfa5fd49$export$d3a4cb300c572c66, {
        data: configData,
        saveCustomGadgetTitle: saveCustomGadgetTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4XFG.RouteResourceValidator), null), children)))));
};

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("yhxNs", function(module, exports) {

$parcel$export(module.exports, "GenericLoadingView", () => $a3f0eec4c468a3cf$export$901c7e24ef786b0f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aYtGv = parcelRequire("aYtGv");

var $84CBi = parcelRequire("84CBi");
const $a3f0eec4c468a3cf$export$901c7e24ef786b0f = ({ customHeight: customHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "generic-loading-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Button, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$Button, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3f0eec4c468a3cf$var$ContainerWrapper, {
        customHeight: customHeight
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3f0eec4c468a3cf$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1y6m _1e0c1txw _1n261g80 _p12f1osq _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$ContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { customHeight: customHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6y8cer": (0, $9t7rW.default)(__cmplp.customHeight),
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71aqf _1bsb1osq _1pbyb4wl",
            __cmplp.customHeight != null ? "_4t3i1hh3" : "_4t3inb68",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _18s8gx6n _1okqidpf _142fidpf _kdjlidpf _1octidpf",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1wug _11q71aqf _4t3izwfg _1bsbclpc",
            __cmplp.className
        ])
    });
});
const $a3f0eec4c468a3cf$var$Button = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _11q71aqf _4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2on8Z", function(module, exports) {

$parcel$export(module.exports, "useConnectApi", () => $d59eb7955bc94cbc$export$521765443e759ceb);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $kEBPk = parcelRequire("kEBPk");

var $01Qi5 = parcelRequire("01Qi5");

var $5lv3X = parcelRequire("5lv3X");

var $6QUMT = parcelRequire("6QUMT");
const $d59eb7955bc94cbc$export$521765443e759ceb = ({ saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    const { data: data, update: update } = (0, $01Qi5.useDashboardResource)();
    const debouncedHeightRef = (0, $eUqFw.useRef)({});
    const [, { addNonRenamable: addNonRenamable, addForcedHeight: addForcedHeight }] = (0, $6QUMT.useGadgetAdditionalStateActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (!data) return;
        const setGadgetTitle = async (id, title)=>{
            if (data.gadgets.some((g)=>g.id === id)) {
                saveCustomGadgetTitle(id, title);
                addNonRenamable(id);
            }
        };
        const setGadgetHeight = (id, height)=>{
            if (debouncedHeightRef.current[id] == null) debouncedHeightRef.current[id] = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((debouncedHeight)=>{
                (0, $5lv3X.updateLocalStorageHeight)(data.id, id, debouncedHeight);
                addForcedHeight(id, debouncedHeight);
            }, (0, $kEBPk.GADGET_HEIGHT_UPDATE_WAIT_TIME));
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            debouncedHeightRef.current[id](height);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isGadgetConfigurable = (id)=>{
            const gadget = data.gadgets.find((g)=>g.id === id);
            const { configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl } = gadget || {};
            return data.writable && (configurable || hasNonHiddenUserPrefs || Boolean(renderedGadgetUrl));
        };
        window.dashboardSpaBridge = {
            setGadgetTitle: setGadgetTitle,
            setGadgetHeight: setGadgetHeight,
            isGadgetConfigurable: isGadgetConfigurable
        };
    }, [
        data,
        addNonRenamable,
        addForcedHeight,
        saveCustomGadgetTitle,
        update
    ]);
};

});
parcelRegister("5lv3X", function(module, exports) {

$parcel$export(module.exports, "getGadgetDataFromLocalStorage", () => $e3672cf42f32f276$export$9d44840cd06e000d);
$parcel$export(module.exports, "putGadgetDataFromLocalStorage", () => $e3672cf42f32f276$export$bfbe102b0a9ddb0b);
$parcel$export(module.exports, "deleteGadgetDataFromLocalStorage", () => $e3672cf42f32f276$export$d0ed0cab2f2757a9);
$parcel$export(module.exports, "updateLocalStorageHeight", () => $e3672cf42f32f276$export$2e93c23f060e835b);
$parcel$export(module.exports, "getLocalStorageHeight", () => $e3672cf42f32f276$export$e31e30011965d5e7);
$parcel$export(module.exports, "getAllLocalStorageHeights", () => $e3672cf42f32f276$export$2590d76ae5192a56);

var $aZaPn = parcelRequire("aZaPn");

var $kEBPk = parcelRequire("kEBPk");
const $e3672cf42f32f276$export$6bac6bdc21b646b4 = (cookieData)=>{
    if (!cookieData) return {};
    const cookieInfos = cookieData.split('|').filter((cookieInfo)=>cookieInfo.trim().length);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return cookieInfos.reduce((acc, cookieInfo)=>{
        const COOKIE_INFO_PATTERN = /(?<cookieKey>.*)=(?<cookieValue>.*)/;
        const matchRes = cookieInfo.match(COOKIE_INFO_PATTERN);
        if (!matchRes) return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { cookieKey: cookieKey, cookieValue: cookieValue } = matchRes.groups;
        if (cookieKey.includes(':')) {
            const [gadgetId, gadgetAttributeName] = cookieKey.split(':');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        } else if (cookieKey.includes('-')) {
            const [, gadgetId, gadgetAttributeName] = cookieKey.split('-');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        }
        return acc;
    }, {});
};
const $e3672cf42f32f276$export$20a3a47cb251067e = (mappedCookieInfo)=>{
    let res = '';
    if (typeof mappedCookieInfo !== 'object') return res;
    Object.keys(mappedCookieInfo).forEach((id)=>{
        const attributeNames = mappedCookieInfo[id];
        if (typeof attributeNames !== 'object') return;
        Object.keys(attributeNames).forEach((attributeName)=>{
            const attributeValue = attributeNames[attributeName];
            if (!attributeValue) return;
            // If res already has contents add the separator
            if (res.length) res += '|';
            if (attributeName.includes('fh')) res += `gadget-${id}-${attributeName}=${attributeValue}`;
            else res += `${id}:${attributeName}=${attributeValue}`;
        });
    });
    return res;
};
const $e3672cf42f32f276$export$ad3e452a397f8ecc = ()=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const cookieData = localStorage.get((0, $kEBPk.GADGET_LOCAL_STORAGE_NAME));
    if (typeof cookieData !== 'string') return '';
    // TODO: Remove when monolith manipulation of gadget local storage is removed.
    // In particular around frame heights of gadgets coming from AG.Cookie.js
    // Issue is the FE local storage provider adds leading and trailing quotations
    // while the old local storage value does not have it. This causes issues when
    // the local storage is dynamically updated by the old monolith code
    // Eg. Might end up with something like '"foo=1"|bar=2'
    // To handle this for now, we remove all quotations
    return cookieData.replace(/"/g, '');
};
const $e3672cf42f32f276$export$9d44840cd06e000d = (id, gadgetDataKey)=>{
    const cleanedCookieData = $e3672cf42f32f276$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $e3672cf42f32f276$export$6bac6bdc21b646b4(cleanedCookieData);
    const gadgetInfo = mappedCookieInfo[id];
    return gadgetInfo?.[gadgetDataKey];
};
const $e3672cf42f32f276$export$bfbe102b0a9ddb0b = (id, gadgetDataKey, value)=>{
    const cleanedCookieData = $e3672cf42f32f276$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $e3672cf42f32f276$export$6bac6bdc21b646b4(cleanedCookieData);
    mappedCookieInfo[id] = mappedCookieInfo[id] ?? {};
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    mappedCookieInfo[id][gadgetDataKey] = value;
    const updatedCookieData = $e3672cf42f32f276$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    localStorage.set((0, $kEBPk.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $e3672cf42f32f276$export$d0ed0cab2f2757a9 = (id, gadgetDataKey)=>{
    const cleanedCookieData = $e3672cf42f32f276$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $e3672cf42f32f276$export$6bac6bdc21b646b4(cleanedCookieData);
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    delete mappedCookieInfo[id][gadgetDataKey];
    const updatedCookieData = $e3672cf42f32f276$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    localStorage.set((0, $kEBPk.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $e3672cf42f32f276$export$2e93c23f060e835b = (dashboardId, gadgetId, height)=>{
    if (dashboardId == null || height == null) return;
    const heightAsInt = Math.round(height);
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME)) ?? {};
    dashboardLocalData[dashboardId] = dashboardLocalData[dashboardId] ?? {};
    const dashboardData = dashboardLocalData[dashboardId];
    dashboardData[gadgetId] = dashboardData[gadgetId] ?? {};
    const gadgetData = dashboardData[gadgetId];
    const storedHeight = gadgetData.height;
    if (storedHeight === heightAsInt) return;
    gadgetData.height = heightAsInt;
    localStorage.set((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME), dashboardLocalData);
};
const $e3672cf42f32f276$export$e31e30011965d5e7 = (dashboardId, gadgetId)=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    const gadgetLocalHeight = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    dashboardLocalData?.[dashboardId]?.[gadgetId]?.height;
    return gadgetLocalHeight !== 0 && gadgetLocalHeight != null ? gadgetLocalHeight : (0, $kEBPk.GADGET_DEFAULT_HEIGHT);
};
const $e3672cf42f32f276$export$2590d76ae5192a56 = (dashboardId)=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $kEBPk.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    return dashboardLocalData?.[dashboardId] ?? {};
};

});

parcelRegister("6QUMT", function(module, exports) {

$parcel$export(module.exports, "useIsRenamable", () => $2bf15318627074cf$export$99680f47796b1368);
$parcel$export(module.exports, "useForcedHeight", () => $2bf15318627074cf$export$6286e5c3de90c7ce);
$parcel$export(module.exports, "useGadgetAdditionalStateActions", () => $2bf15318627074cf$export$7050d853cb5c3b12);
$parcel$export(module.exports, "GadgetAdditionalStateContainer", () => $2bf15318627074cf$export$c59b94948beb035f);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $2bf15318627074cf$var$actions = {
    addNonRenamable: (id)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newIds = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                isNonRenamable: true
            }));
            setState({
                idToStateMap: newIds
            });
        },
    addForcedHeight: (id, forcedHeight)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newGadgetIdToStateMap = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                forcedHeight: forcedHeight
            }));
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        },
    remove: (id)=>({ setState: setState, getState: getState })=>{
            if (!getState().idToStateMap.has(id)) return;
            const newGadgetIdToStateMap = new Map(getState().idToStateMap);
            newGadgetIdToStateMap.delete(id);
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        }
};
const $2bf15318627074cf$var$Store = (0, $a61MH.createStore)({
    name: 'gadget-additional-state',
    initialState: {
        idToStateMap: new Map()
    },
    actions: $2bf15318627074cf$var$actions
});
const $2bf15318627074cf$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $2bf15318627074cf$export$99680f47796b1368 = $2bf15318627074cf$export$b8a31aa234db5dc9((0, $ggKAj.createHook)($2bf15318627074cf$var$Store, {
    selector: (state, id)=>!state.idToStateMap.get(id)?.isNonRenamable
}));
const $2bf15318627074cf$export$6286e5c3de90c7ce = $2bf15318627074cf$export$b8a31aa234db5dc9((0, $ggKAj.createHook)($2bf15318627074cf$var$Store, {
    selector: (state, id)=>state.idToStateMap.get(id)?.forcedHeight
}));
const $2bf15318627074cf$export$7050d853cb5c3b12 = (0, $ggKAj.createHook)($2bf15318627074cf$var$Store, {
    selector: null
});
const $2bf15318627074cf$export$c59b94948beb035f = (0, $heB5U.createContainer)($2bf15318627074cf$var$Store);

});


parcelRegister("dYru8", function(module, exports) {

$parcel$export(module.exports, "useDashboardAnalytics", () => $cac1e3c84e8844b6$export$6da6d2b3a61f8861);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $cac1e3c84e8844b6$export$6da6d2b3a61f8861 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(({ eventType: eventType, actionSubject: actionSubject, action: action, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        let fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        // All of the events have exactly the same signature and transformations underneath.
        switch(eventType){
            case 0, $41ea3621645e2acc$export$947dac6c72b26f81:
                fireAnalytics = (0, $jMP2a.fireTrackAnalytics);
                break;
            case 0, $41ea3621645e2acc$export$12346a674644c156:
                fireAnalytics = (0, $jMP2a.fireOperationalAnalytics);
                break;
            case 0, $41ea3621645e2acc$export$a1562d08625f5d7e:
                fireAnalytics = (0, $jMP2a.fireUIAnalytics);
                break;
            case 0, $41ea3621645e2acc$export$f1d537d508d2945a:
                fireAnalytics = (0, $jMP2a.fireScreenAnalytics);
                break;
            default:
                fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        }
        fireAnalytics(createAnalyticsEvent({}), `${actionSubject} ${action}`, actionSubjectId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        attributes);
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("4UDpw", function(module, exports) {

$parcel$export(module.exports, "useGadgetMetricsBridge", () => $fd619abbf3898685$export$a81a90ecebb273c6);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $78d1w = parcelRequire("78d1w");

var $aIeBA = parcelRequire("aIeBA");

var $179bk = parcelRequire("179bk");

var $179bk = parcelRequire("179bk");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $e01k4 = parcelRequire("e01k4");

var $6ofMt = parcelRequire("6ofMt");
const $fd619abbf3898685$var$OVERALL_TIMEOUT = 60000;
const $fd619abbf3898685$var$buildEventKey = (event)=>{
    if (event.eventType !== (0, $kF6iw.GADGET_MARK_EVENT_PREFIX) || event.markName == null || event.markStage == null) return event.eventType;
    return `${0, $kF6iw.GADGET_MARK_EVENT_PREFIX}-${event.markName}-${event.markStage}`;
};
const $fd619abbf3898685$export$b70b6efb2347a731 = (gadgetMetricsEvents, gadgetId, event)=>{
    let recorded = gadgetMetricsEvents.get(gadgetId);
    if (recorded == null) {
        recorded = {
            contentType: 'Unspecified',
            source: event.source,
            events: new Map()
        };
        gadgetMetricsEvents.set(gadgetId, recorded);
    }
    if (recorded.contentType !== 'ErrorMessage' && event.contentType !== 'Unspecified') recorded.contentType = event.contentType;
    const record = {
        spaTime: Date.now()
    };
    if (!recorded.events.has($fd619abbf3898685$var$buildEventKey(event))) recorded.events.set($fd619abbf3898685$var$buildEventKey(event), record);
};
const $fd619abbf3898685$export$8aed66d0a3a7041d = (gadgets)=>gadgets.filter((item)=>item.amdModule != null || item.forge != null || item.reactKey != null)// Include only gadgets in the inclusion list
    .filter((item)=>// report all forge and react gadgets
        item.forge != null || item.reactKey != null || (0, $6ofMt.GADGETS_TO_REPORT).has(item.amdModule ?? '')).map((gadget)=>gadget.id);
const $fd619abbf3898685$export$b2ee8eefeb9c97ce = (gadgets)=>gadgets// Include only WRM gadget
    .filter((item)=>item.amdModule != null)// exclude connect gadgets
    .filter((item)=>!(0, $kF6iw.CONNECT_MODULE_PATTERN).test(item.amdModule || ''))// find gadgets not in either inclusion list or exclusion list
    .filter((item)=>!(0, $6ofMt.GADGETS_TO_REPORT).has(item.amdModule ?? '') && !(0, $6ofMt.GADGETS_IGNORED).has(item.amdModule ?? ''));
// Currently WRM gadget does not send render finish event in Config mode so we don't have accurate TTI for it
const $fd619abbf3898685$var$shouldSendGadgetMetrics = (event)=>!(event.source === (0, $kF6iw.WRM_GADGET_METRICS) && event.contentType === 'Config');
const $fd619abbf3898685$export$a81a90ecebb273c6 = (dashboardId, gadgets, layout)=>{
    const currentDashboardId = (0, $eUqFw.useRef)(null);
    // Metrics context in the a dashboard lifecycle.
    const dashboardMetricsContext = (0, $eUqFw.useRef)(null);
    const [, { registerListener: registerMessageListener, unregisterListener: unregisterMessageListener, broadcastMessage: broadcastMessageListener }] = (0, $iKzwQ.useMessageBus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { sendGadgetMetrics: sendGadgetMetrics, sendOverallGadgetMetrics: sendOverallGadgetMetrics, onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender, resetScrollStartMetrics: resetScrollStartMetrics } = (0, $e01k4.useGadgetMetricsAnalytics)(dashboardId);
    const [, { onGadgetRender: onGadgetRender }] = (0, $179bk.useRenderAboveTheFold)();
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { name: routeName } = (0, $10fdS.useCurrentRoute)();
    if (currentDashboardId.current == null || currentDashboardId.current !== dashboardId) {
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'dashboardMetricsContext renewed', {
            dashboardId: dashboardId,
            previousDashboardId: currentDashboardId.current,
            currentPageId: currentPageId
        });
        resetScrollStartMetrics();
        // Dashboard reinitialised or changed
        currentDashboardId.current = dashboardId;
        if (dashboardMetricsContext.current?.metricsTimeout != null) clearTimeout(dashboardMetricsContext.current.metricsTimeout);
        const extractedGadgets = $fd619abbf3898685$export$8aed66d0a3a7041d(gadgets);
        const allAboveTheFoldGadgets = (0, $179bk.getAboveTheFoldGadgets)((0, $aIeBA.toColumns)(gadgets, layout), dashboardId);
        dashboardMetricsContext.current = {
            gadgetMetricsEvents: new Map(),
            gadgetIdsInOverallAnalytics: extractedGadgets,
            gadgetIdsInTti: extractedGadgets.filter((gadgetId)=>allAboveTheFoldGadgets.has(gadgetId)),
            allGadgetIds: gadgets.map((item)=>item.id),
            overallMetricsSent: false,
            atfMetricsSent: false,
            implicitlyIgnoredGadgetLogged: false,
            gadgetRenderStartTime: Date.now(),
            metricsTimeout: setTimeout(()=>{
                broadcastMessageListener((0, $kEBPk.GADGET_METRICS_TYPE).TIMEOUT, {}, {});
            }, $fd619abbf3898685$var$OVERALL_TIMEOUT),
            timestamps: {
                created: Date.now(),
                pnow: performance?.now(),
                currentPageId: currentPageId,
                lastTransitionStartTime: lastTransitionStartTime,
                navigationStart: navigationStart,
                navStart: (0, $e01k4.getNavStart)(isInitialRender, lastTransitionStartTime, navigationStart)
            }
        };
    }
    const gadgetMetricsTimeout = (0, $eUqFw.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        context.metricsTimeout = undefined;
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        context.overallMetricsSent = true;
        // Send metrics for timed out gadget that sent at least one event.
        context.gadgetMetricsEvents.forEach((item, id)=>{
            if (item.allEventHandled !== true) {
                // eslint-disable-next-line no-param-reassign
                item.timedOut = true;
                sendGadgetMetrics(id, item);
            }
        });
        // Send metrics for idle gadgets that haven't sent any event
        context.gadgetIdsInOverallAnalytics.filter((id)=>!context.gadgetMetricsEvents.has(id)).forEach((id)=>{
            sendGadgetMetrics(id, {
                source: (0, $kF6iw.IDLE_GADGET_SOURCE),
                timedOut: true,
                events: new Map()
            });
        });
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, true);
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, true);
    }, [
        sendGadgetMetrics,
        sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender
    ]);
    const onAllGadgetHandled = (0, $eUqFw.useCallback)(()=>{
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        context.overallMetricsSent = true;
        if (context.metricsTimeout != null) {
            clearTimeout(context.metricsTimeout);
            context.metricsTimeout = undefined;
        }
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, false);
    }, [
        sendOverallGadgetMetrics
    ]);
    const onAboveTheFoldGadgetsHandled = (0, $eUqFw.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, false);
        context.atfMetricsSent = true;
    }, [
        onAboveTheFoldGadgetsRender
    ]);
    const gadgetMetricsListener = (0, $eUqFw.useCallback)((gid, command, ...args)=>{
        if (command !== 'metrics_event' || !args[0]) return;
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        const eventData = args[0];
        const eventsPerGadget = (0, $e01k4.getAllEventHandlers)(eventData.source, eventData.contentType);
        const { pageId: pageIdInEvent } = eventData;
        // If the gadget id for the event is not in the current gadgetIds list, it is from a stale gadget of the previous dashboard
        if (currentPageId !== pageIdInEvent || context.allGadgetIds.every((id)=>id !== gid)) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `Page [${currentPageId ?? ''}] recieved staled gadget metrics event [${eventData.eventType}] from gadget [${gid}] in page [${pageIdInEvent ?? ''}]`);
            return;
        }
        // Check if all expected events for a gadget are triggered and handled
        const isAllGadgetEventsHandled = (gadgetEvents)=>gadgetEvents?.allEventHandled === true || gadgetEvents?.timedOut === true || eventsPerGadget.every((e)=>gadgetEvents?.events.has(e));
        // Check if all gadgets has been handled
        const isAllGadgetHandled = (gadgetIds)=>gadgetIds.every((id)=>context.gadgetMetricsEvents.get(id)?.allEventHandled);
        if (context.gadgetMetricsEvents.has(gid)) {
            if (isAllGadgetEventsHandled(context.gadgetMetricsEvents.get(gid))) // gadget has been handled
            return;
            if (context.gadgetMetricsEvents.get(gid)?.events.has($fd619abbf3898685$var$buildEventKey(eventData))) // event has been handled
            return;
        }
        $fd619abbf3898685$export$b70b6efb2347a731(context.gadgetMetricsEvents, gid, eventData);
        const event = context.gadgetMetricsEvents.get(gid);
        if (event != null && isAllGadgetEventsHandled(event)) {
            event.allEventHandled = true;
            if ($fd619abbf3898685$var$shouldSendGadgetMetrics(event)) {
                onGadgetRender(gid);
                sendGadgetMetrics(gid, event);
            }
            // if all above the fold gadgets are handled,  send gadgets metrics
            if (context.atfMetricsSent === false) {
                if (isAllGadgetHandled(context.gadgetIdsInTti)) onAboveTheFoldGadgetsHandled();
            }
            // if all gadgets are handled, send overall metrics
            if (isAllGadgetHandled(context.gadgetIdsInOverallAnalytics)) {
                onAllGadgetHandled();
                if (context.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
            }
        }
    }, [
        currentPageId,
        onAboveTheFoldGadgetsHandled,
        onAllGadgetHandled,
        sendGadgetMetrics,
        onGadgetRender
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // NOTE - This is temporary until we fix metrics for wallboard
            if (routeName === 'dashboard-wallboard') return;
            if (dashboardMetricsContext.current?.metricsTimeout != null) {
                clearTimeout(dashboardMetricsContext.current.metricsTimeout);
                dashboardMetricsContext.current.metricsTimeout = undefined;
            }
        }, [
        routeName
    ]);
    const gadgetMetricsMessageBusListenerAdaptor = (0, $eUqFw.useCallback)((type, message, context)=>{
        if (type !== (0, $kEBPk.GADGET_METRICS_TYPE).REPORT) return;
        const { gadgetId: gid, pageId: pageId } = context;
        if (gid == null) return;
        gadgetMetricsListener(gid, 'metrics_event', {
            ...message,
            pageId: pageId
        });
    }, [
        gadgetMetricsListener
    ]);
    const timeoutMessageBusListenerAdaptor = (0, $eUqFw.useCallback)((type)=>{
        if (type !== (0, $kEBPk.GADGET_METRICS_TYPE).TIMEOUT) return;
        gadgetMetricsTimeout();
    }, [
        gadgetMetricsTimeout
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // NOTE - This is temporary until we fix metrics for wallboard
        if (routeName === 'dashboard-wallboard') // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        registerMessageListener(gadgetMetricsMessageBusListenerAdaptor);
        registerMessageListener(timeoutMessageBusListenerAdaptor);
        return ()=>{
            unregisterMessageListener(gadgetMetricsMessageBusListenerAdaptor);
            unregisterMessageListener(timeoutMessageBusListenerAdaptor);
        };
    }, [
        gadgetMetricsMessageBusListenerAdaptor,
        gadgetMetricsListener,
        registerMessageListener,
        timeoutMessageBusListenerAdaptor,
        unregisterMessageListener,
        routeName
    ]);
    // NOTE - This is temporary until we fix metrics for wallboard
    if (routeName === 'dashboard-wallboard') return;
    if (dashboardMetricsContext.current == null || dashboardMetricsContext.current.overallMetricsSent === true) return;
    // Send overall event immediately for empty dashboard
    if (dashboardMetricsContext.current?.gadgetIdsInOverallAnalytics.length === 0) {
        onAboveTheFoldGadgetsHandled();
        onAllGadgetHandled();
    } else if (dashboardMetricsContext.current?.gadgetIdsInTti.length === 0 && dashboardMetricsContext.current?.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
    if (dashboardMetricsContext.current != null && !dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged) {
        dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged = true;
        $fd619abbf3898685$export$b2ee8eefeb9c97ce(gadgets).forEach((item)=>{
            (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics for gadget [${item.amdModule ?? 'unknown'}] is ignored implicitly.`);
        });
    }
};

});
parcelRegister("aIeBA", function(module, exports) {

$parcel$export(module.exports, "toColumns", () => $a3ebb36e3a8b3c10$export$755ca66aa40344da);
const $a3ebb36e3a8b3c10$export$755ca66aa40344da = (gadgets, layout)=>{
    const getGadgetsForCol = (col)=>gadgets.filter((gadget)=>gadget.column === col);
    switch(layout){
        case 'A':
            return [
                getGadgetsForCol(0)
            ];
        case 'AA':
        case 'AB':
        case 'BA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1)
            ];
        case 'AAA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1),
                getGadgetsForCol(2)
            ];
        default:
            throw new Error('Unexpected layout was provided');
    }
};

});

parcelRegister("179bk", function(module, exports) {

$parcel$export(module.exports, "getAboveTheFoldGadgets", () => $e3df20c67c77a5d1$export$e12eddecf5e86fe5);
$parcel$export(module.exports, "useRenderAboveTheFold", () => $e3df20c67c77a5d1$export$16f58cfd4c8ccf70);
$parcel$export(module.exports, "RenderAboveTheFoldContainer", () => $e3df20c67c77a5d1$export$9710049f7f21917b);
$parcel$export(module.exports, "useOnGadgetRender", () => $e3df20c67c77a5d1$export$c127791d148e941c);
$parcel$export(module.exports, "useOnGadgetRenderEffect", () => $e3df20c67c77a5d1$export$1f28971b410f9e3);
$parcel$export(module.exports, "useShouldRenderGadget", () => $e3df20c67c77a5d1$export$428a5d740650db3e);
$parcel$export(module.exports, "useLocalStorageGadgetHeight", () => $e3df20c67c77a5d1$export$94d0a966fb813ab7);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $kEBPk = parcelRequire("kEBPk");

var $5lv3X = parcelRequire("5lv3X");
const $e3df20c67c77a5d1$var$TOP_NAVIGATION_HEIGHT = 56;
const $e3df20c67c77a5d1$var$DASHBOARD_HEADER_HEIGHT = 80;
const $e3df20c67c77a5d1$var$GADGET_HEADER_AND_FOOTER_HEIGHT = 84;
const $e3df20c67c77a5d1$var$PRIORITISED_RENDERING_TIMEOUT = 7000;
const $e3df20c67c77a5d1$export$e12eddecf5e86fe5 = (columns, dashboardId)=>{
    const aboveTheFoldGadgets = new Set();
    const availableViewportHeight = window.innerHeight - $e3df20c67c77a5d1$var$TOP_NAVIGATION_HEIGHT - $e3df20c67c77a5d1$var$DASHBOARD_HEADER_HEIGHT;
    columns.forEach((column)=>{
        let occupiedViewportHeight = 0;
        column.some((gadget)=>{
            if (occupiedViewportHeight < availableViewportHeight) {
                const gadgetHeight = (0, $5lv3X.getLocalStorageHeight)(dashboardId, gadget.id) + $e3df20c67c77a5d1$var$GADGET_HEADER_AND_FOOTER_HEIGHT;
                aboveTheFoldGadgets.add(gadget.id);
                occupiedViewportHeight += gadgetHeight;
                return false;
            }
            // if we have enough height, we terminate the loop
            return true;
        });
    });
    return aboveTheFoldGadgets;
};
const $e3df20c67c77a5d1$export$e324594224ef24da = {
    onGadgetRender: (gadgetId, height)=>({ setState: setState, getState: getState })=>{
            const { dashboardId: dashboardId, loadingAboveTheFold: hasAboveTheFold, timeoutId: timeoutLast } = getState();
            // Always return default for wallboard, where dashboardId is null
            if (dashboardId === null) return;
            // we want this to always happen whenever onGadgetRender is called
            if (height != null) {
                (0, $5lv3X.updateLocalStorageHeight)(dashboardId, gadgetId, height);
                setState({
                    localStorageGadgetHeights: {
                        // we can't use this from the state as it might be stale due to other gadgets
                        // possibly updating their heights directly in localStorage
                        ...(0, $5lv3X.getAllLocalStorageHeights)(dashboardId),
                        [gadgetId]: {
                            height: height
                        }
                    }
                });
            }
            if (!hasAboveTheFold) return;
            const remainingAboveTheFoldGadgets = new Set(getState().remainingAboveTheFoldGadgets);
            remainingAboveTheFoldGadgets.delete(gadgetId);
            const loadingAboveTheFold = Boolean(remainingAboveTheFoldGadgets.size);
            const timeoutId = loadingAboveTheFold ? timeoutLast : null;
            if (timeoutLast && !timeoutId) clearTimeout(timeoutLast);
            setState({
                remainingAboveTheFoldGadgets: remainingAboveTheFoldGadgets,
                loadingAboveTheFold: loadingAboveTheFold,
                timeoutId: timeoutId
            });
        }
};
const $e3df20c67c77a5d1$var$Store = (0, $a61MH.createStore)({
    name: 'RenderAboveTheFold',
    initialState: {
        dashboardId: null,
        loadingAboveTheFold: true,
        aboveTheFoldGadgets: new Set(),
        remainingAboveTheFoldGadgets: new Set(),
        timeoutId: null,
        timeout: false,
        localStorageGadgetHeights: {}
    },
    actions: $e3df20c67c77a5d1$export$e324594224ef24da
});
const $e3df20c67c77a5d1$export$16f58cfd4c8ccf70 = (0, $ggKAj.createHook)($e3df20c67c77a5d1$var$Store);
const $e3df20c67c77a5d1$export$f0ff1fd44503e803 = (0, $ggKAj.createHook)($e3df20c67c77a5d1$var$Store, {
    selector: null
});
const $e3df20c67c77a5d1$export$9710049f7f21917b = (0, $heB5U.createContainer)($e3df20c67c77a5d1$var$Store, {
    onInit: ()=>({ setState: setState, getState: getState }, { columns: columns, dashboardId: dashboardId })=>{
            if (getState().dashboardId !== dashboardId && dashboardId != null) {
                const loadingAboveTheFoldTimeout = ()=>{
                    setState({
                        remainingAboveTheFoldGadgets: new Set(),
                        loadingAboveTheFold: false,
                        timeout: true
                    });
                };
                const aboveTheFoldGadgets = $e3df20c67c77a5d1$export$e12eddecf5e86fe5(columns, dashboardId);
                // calculate gadgets
                setState({
                    dashboardId: dashboardId,
                    aboveTheFoldGadgets: aboveTheFoldGadgets,
                    remainingAboveTheFoldGadgets: new Set(aboveTheFoldGadgets),
                    loadingAboveTheFold: Boolean(aboveTheFoldGadgets.size),
                    timeoutId: setTimeout(loadingAboveTheFoldTimeout, $e3df20c67c77a5d1$var$PRIORITISED_RENDERING_TIMEOUT),
                    timeout: false,
                    localStorageGadgetHeights: (0, $5lv3X.getAllLocalStorageHeights)(dashboardId)
                });
            }
        }
});
const $e3df20c67c77a5d1$export$c127791d148e941c = (id)=>{
    const [, { onGadgetRender: onGadgetRender }] = $e3df20c67c77a5d1$export$f0ff1fd44503e803();
    return (0, $eUqFw.useCallback)((height)=>onGadgetRender(id, height), [
        id,
        onGadgetRender
    ]);
};
const $e3df20c67c77a5d1$export$1f28971b410f9e3 = (id, gadgetRef)=>{
    const onGadgetRender = $e3df20c67c77a5d1$export$c127791d148e941c(id);
    (0, $eUqFw.useEffect)(()=>{
        onGadgetRender(gadgetRef?.getBoundingClientRect().height);
    }, [
        onGadgetRender,
        gadgetRef
    ]);
};
const $e3df20c67c77a5d1$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $e3df20c67c77a5d1$export$428a5d740650db3e = $e3df20c67c77a5d1$export$b8a31aa234db5dc9((0, $ggKAj.createHook)($e3df20c67c77a5d1$var$Store, {
    selector: ({ loadingAboveTheFold: loadingAboveTheFold, aboveTheFoldGadgets: aboveTheFoldGadgets, dashboardId: dashboardId }, gadgetId)=>{
        // Always return true for wallboard, where the dashboardId isn't defined as it uses query parameters instead
        if (dashboardId === null) return true;
        return !loadingAboveTheFold || aboveTheFoldGadgets.has(gadgetId);
    }
}));
const $e3df20c67c77a5d1$export$94d0a966fb813ab7 = $e3df20c67c77a5d1$export$b8a31aa234db5dc9((0, $ggKAj.createHook)($e3df20c67c77a5d1$var$Store, {
    selector: ({ localStorageGadgetHeights: localStorageGadgetHeights }, gadgetId)=>localStorageGadgetHeights[gadgetId]?.height ?? (0, $kEBPk.GADGET_DEFAULT_HEIGHT)
}));

});

parcelRegister("iKzwQ", function(module, exports) {

$parcel$export(module.exports, "useMessageBus", () => $5724c607f8adc142$export$69241ffa7d4e8d8d);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $5724c607f8adc142$var$actions = {
    registerListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: [
                    ...listeners,
                    listener
                ]
            });
        },
    unregisterListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: listeners.filter((cb)=>cb !== listener)
            });
        },
    broadcastMessage: (type, message, context)=>({ getState: getState })=>{
            getState().listeners.forEach((listener)=>listener(type, message, context));
        }
};
const $5724c607f8adc142$var$Store = (0, $a61MH.createStore)({
    name: 'dashboard-message-bus',
    initialState: {
        listeners: []
    },
    actions: $5724c607f8adc142$var$actions
});
const $5724c607f8adc142$export$69241ffa7d4e8d8d = (0, $ggKAj.createHook)($5724c607f8adc142$var$Store);

});

parcelRegister("kF6iw", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_GADGET_TYPE", () => $3fbc7688877dfc38$export$4db4c2521224b627);
$parcel$export(module.exports, "CONNECT_MODULE_PATTERN", () => $3fbc7688877dfc38$export$c1ee01d79441a123);
$parcel$export(module.exports, "FORGE_MODULE_PATTERN", () => $3fbc7688877dfc38$export$216b1f7517647987);
$parcel$export(module.exports, "WRM_GADGET_METRICS", () => $3fbc7688877dfc38$export$747c046b02db553e);
$parcel$export(module.exports, "FORGE_GADGET_METRICS", () => $3fbc7688877dfc38$export$fd11359c208e3b3d);
$parcel$export(module.exports, "REACT_GADGET_METRICS", () => $3fbc7688877dfc38$export$e6e5910bcc3a541f);
$parcel$export(module.exports, "FALLBACK_GADGET_SOURCE", () => $3fbc7688877dfc38$export$b17b847ae2e73914);
$parcel$export(module.exports, "IDLE_GADGET_SOURCE", () => $3fbc7688877dfc38$export$8e7a356fc2e45e1);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PREFIX", () => $3fbc7688877dfc38$export$deb23548f6bb4aa6);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PATTERN", () => $3fbc7688877dfc38$export$dc82d3f06c18522e);
$parcel$export(module.exports, "GADGET_RENDER_CONTAINER_EVENT", () => $3fbc7688877dfc38$export$479474c5d2f30a0a);
$parcel$export(module.exports, "GADGET_START_EVENT", () => $3fbc7688877dfc38$export$76b0ea781056f8d3);
$parcel$export(module.exports, "GADGET_RENDERING_FINISHED_EVENT", () => $3fbc7688877dfc38$export$b9c9f3ffa9290059);
$parcel$export(module.exports, "DEFAULT_WRM_GADGET_EVENTS", () => $3fbc7688877dfc38$export$f34d5b0533833e95);
const $3fbc7688877dfc38$export$4db4c2521224b627 = 'unknown';
const $3fbc7688877dfc38$export$c1ee01d79441a123 = /^atlassian-connect\/.*/;
const $3fbc7688877dfc38$export$216b1f7517647987 = /^ari:cloud:ecosystem::extension\/.*/;
const $3fbc7688877dfc38$export$747c046b02db553e = 'wrm_gadget_metrics';
const $3fbc7688877dfc38$export$fd11359c208e3b3d = 'forge_gadget_metrics';
const $3fbc7688877dfc38$export$e6e5910bcc3a541f = 'react_gadget_metrics';
const $3fbc7688877dfc38$export$b17b847ae2e73914 = 'fallback_gadget';
const $3fbc7688877dfc38$export$8e7a356fc2e45e1 = 'idle_gadget';
const $3fbc7688877dfc38$export$deb23548f6bb4aa6 = 'gadget-mark';
const $3fbc7688877dfc38$export$dc82d3f06c18522e = new RegExp(`^${$3fbc7688877dfc38$export$deb23548f6bb4aa6}-(.+)-(start|end)$`);
const $3fbc7688877dfc38$export$479474c5d2f30a0a = 'gadget-render-container';
const $3fbc7688877dfc38$export$593632c36804eee0 = 'gadget-dom-ready';
const $3fbc7688877dfc38$export$c10c3db63be202d5 = 'gadget-loaded';
const $3fbc7688877dfc38$export$76b0ea781056f8d3 = 'gadget-start';
const $3fbc7688877dfc38$export$b9c9f3ffa9290059 = 'gadget-rendering-finished';
const $3fbc7688877dfc38$export$eebee3f00d7d097d = 'gadget-sync-rendering-finished';
const $3fbc7688877dfc38$export$f34d5b0533833e95 = [
    $3fbc7688877dfc38$export$479474c5d2f30a0a,
    $3fbc7688877dfc38$export$76b0ea781056f8d3,
    $3fbc7688877dfc38$export$b9c9f3ffa9290059
];

});

parcelRegister("e01k4", function(module, exports) {

$parcel$export(module.exports, "getAllEventHandlers", () => $9d91f5788035531f$export$835bb833cb903f59);
$parcel$export(module.exports, "getNavStart", () => $9d91f5788035531f$export$f409d0aa399347ac);
$parcel$export(module.exports, "useGadgetMetricsAnalytics", () => $9d91f5788035531f$export$ea517a7cfce02895);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lMwBY = parcelRequire("lMwBY");

var $45wsB = parcelRequire("45wsB");

var $kJlBc = parcelRequire("kJlBc");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");

var $1QVWH = parcelRequire("1QVWH");

var $fVaJL = parcelRequire("fVaJL");

var $dFjTU = parcelRequire("dFjTU");
var $ces19 = parcelRequire("ces19");

var $rekMK = parcelRequire("rekMK");
var $179bk = parcelRequire("179bk");

var $kF6iw = parcelRequire("kF6iw");
// At time of writing BM3 doesn't support ssrFeatureFlags unless your page performs initial-paint
// in ssr (not just skeleton content), which Dashboard does not.
// We are forced to recreate here based on "@atlassian/jira-browser-metrics".
// We cannot reference code from BM directly since it gets removed in storybook, causing errors.
const $9d91f5788035531f$var$getSSRFeatureFlags = (0, $5iWql.default)(()=>{
    try {
        const metaTagValue = (0, $6rW04.default)('spa-service-flags');
        return metaTagValue != null && JSON.parse(metaTagValue) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $9d91f5788035531f$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {},
    wasExperienceSuccesful: true
};
// All expected metrics events from a WRM gadget in Config mode
const $9d91f5788035531f$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS = [
    (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT)
];
// Expected metrics events from immediately finished gadgets e.g. fallbacks
const $9d91f5788035531f$var$IMMEDIATE_FINISH_GADGET_EVENTS = [
    (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT)
];
// Events send by the gadget container, which should not be counted to determine idle gadget
const $9d91f5788035531f$var$GADGET_CONTAINER_EVENTS = new Set([
    (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT)
]);
const $9d91f5788035531f$export$835bb833cb903f59 = (eventSource, contentType = 'View')=>{
    if (eventSource === (0, $kF6iw.WRM_GADGET_METRICS) || eventSource === (0, $kF6iw.FORGE_GADGET_METRICS) || eventSource === (0, $kF6iw.REACT_GADGET_METRICS)) return contentType === 'Config' ? $9d91f5788035531f$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS : (0, $kF6iw.DEFAULT_WRM_GADGET_EVENTS);
    return $9d91f5788035531f$var$IMMEDIATE_FINISH_GADGET_EVENTS;
};
const $9d91f5788035531f$var$isIdle = (gadgetEventRecord)=>{
    if (gadgetEventRecord == null) return false;
    if (gadgetEventRecord.source === (0, $kF6iw.IDLE_GADGET_SOURCE)) return true;
    const eventEntries = Array.from(gadgetEventRecord.events.entries());
    return eventEntries.length === $9d91f5788035531f$var$GADGET_CONTAINER_EVENTS.size && eventEntries.every((entry)=>$9d91f5788035531f$var$GADGET_CONTAINER_EVENTS.has(entry[0]));
};
const $9d91f5788035531f$export$b1f29dd0b70f467b = (events)=>{
    const customMarksMap = {};
    const customMarksList = [];
    events.forEach((event, eventKey)=>{
        const parts = (0, $kF6iw.GADGET_MARK_EVENT_PATTERN).exec(eventKey);
        if (parts == null) return;
        const key = parts[1];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const stage = parts[2];
        const customMark = customMarksMap[key];
        if (customMark == null) {
            const newCustomMark = {
                name: `gadgetMark_${key}`,
                [stage]: event.spaTime
            };
            customMarksMap[key] = newCustomMark;
            customMarksList.push(newCustomMark);
        } else customMark[stage] = event.spaTime;
    });
    return customMarksList;
};
const $9d91f5788035531f$var$getInitialMarks = (context)=>({
        TTI: Date.now() - Number(context.navStart),
        isInitialRender: context.isInitialRender,
        isWritable: context.isWritable,
        isRouteReplaced: context.isRouteReplaced,
        currentPageId: context.currentPageId,
        // TODO should be removed in favour of BM3 pageVisible property
        pageVisible: !window?.document?.hidden,
        ssrFeatureFlags: $9d91f5788035531f$var$getSSRFeatureFlags(),
        featureFlags: (0, $ces19.getDashboardFeatureFlags)(),
        centralised: true
    });
const $9d91f5788035531f$export$f409d0aa399347ac = (isInitialRender, lastTransitionStartTime, navigationStart)=>{
    const sessionStart = navigationStart != null ? new Date(navigationStart).getTime() : 0;
    return !isInitialRender && lastTransitionStartTime != null ? lastTransitionStartTime : sessionStart;
};
const $9d91f5788035531f$var$isInvalidContextState = (metricsContextTimeStamp, currentNavStart, currentPageId)=>{
    if (metricsContextTimeStamp.currentPageId !== currentPageId) return true;
    if (metricsContextTimeStamp.created < metricsContextTimeStamp.navStart) return true;
    const now = Date.now();
    if (now < metricsContextTimeStamp.navStart) return true;
    if (now < Number(currentNavStart)) return true;
    return false;
};
const $9d91f5788035531f$export$ea517a7cfce02895 = (dashboardId)=>{
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId = 'unknown' }] = (0, $78d1w.useSpaStateTransition)();
    const [{ aboveTheFoldGadgets: aboveTheFoldGadgets }] = (0, $179bk.useRenderAboveTheFold)();
    const [routerState] = (0, $kJlBc.useRouter)();
    const navStart = $9d91f5788035531f$export$f409d0aa399347ac(isInitialRender, lastTransitionStartTime, navigationStart);
    const dashboardData = (0, $01Qi5.useDashboardResource)().data;
    const { scrollStartTimestamp: scrollStartTimestamp, resetScrollStartTime: resetScrollStartTime } = (0, $rekMK.useDashboardScrollAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const newContext = {
        dashboardId: dashboardId,
        isInitialRender: isInitialRender,
        isRouteReplaced: routerState.action === 'REPLACE',
        lastTransitionStartTime: lastTransitionStartTime,
        navigationStart: navigationStart,
        currentPageId: currentPageId,
        navStart: navStart,
        gadgets: dashboardData?.gadgets,
        isWritable: dashboardData?.writable ?? false,
        scrollStartTimestamp: scrollStartTimestamp,
        aboveTheFoldGadgets: aboveTheFoldGadgets,
        resetScrollStartTime: resetScrollStartTime
    };
    const context = (0, $eUqFw.useRef)(newContext);
    context.current = newContext;
    const sendGadgetMetrics = (0, $eUqFw.useCallback)((gadgetId, gadgetEventRecord)=>{
        if (context.current.navigationStart == null) return;
        const gadgetModel = context.current.gadgets?.find((item)=>item.id === gadgetId) || null;
        // Setup common marks first
        const customMarks = {
            ...$9d91f5788035531f$var$getInitialMarks(context.current),
            timeout: gadgetEventRecord.timedOut === true,
            gadgetContentType: gadgetEventRecord.contentType,
            isAboveTheFold: context.current.aboveTheFoldGadgets.has(gadgetId)
        };
        // Timeout Marks
        if (gadgetEventRecord.timedOut === true) {
            if ($9d91f5788035531f$var$isIdle(gadgetEventRecord)) customMarks.timeout_idle = true;
            else $9d91f5788035531f$export$835bb833cb903f59(gadgetEventRecord.source, gadgetEventRecord.contentType).filter((event)=>!$9d91f5788035531f$var$GADGET_CONTAINER_EVENTS.has(event)).filter((event)=>!gadgetEventRecord.events.has(event)).forEach((event)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                customMarks[`timeout_${event}`] = true;
            });
        }
        if (gadgetEventRecord.source === (0, $kF6iw.WRM_GADGET_METRICS) || gadgetEventRecord.source === (0, $kF6iw.FORGE_GADGET_METRICS) || gadgetEventRecord.source === (0, $kF6iw.REACT_GADGET_METRICS)) {
            customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || gadgetModel?.reactKey || (0, $kF6iw.UNKNOWN_GADGET_TYPE);
            const renderContainer = gadgetEventRecord.events.get((0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT));
            const start = gadgetEventRecord.events.get((0, $kF6iw.GADGET_START_EVENT));
            if (renderContainer != null) customMarks.gadgetRenderContainer = renderContainer.spaTime - Number(context.current.navStart);
            if (start != null) {
                customMarks.gadgetStartTime = start.spaTime - Number(context.current.navStart);
                customMarks.gadgetDuration = Date.now() - start.spaTime;
            }
        } else if (gadgetEventRecord.source === (0, $kF6iw.IDLE_GADGET_SOURCE) || gadgetEventRecord.source === (0, $kF6iw.FALLBACK_GADGET_SOURCE)) // The gadget doesn't send any event till timed out
        customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || (0, $kF6iw.UNKNOWN_GADGET_TYPE);
        $9d91f5788035531f$export$b1f29dd0b70f467b(gadgetEventRecord.events).forEach((gadgetMark)=>{
            if (gadgetMark.start != null) customMarks[`${gadgetMark.name}-start`] = gadgetMark.start - Number(context.current.navStart);
            if (gadgetMark.start != null && gadgetMark.end != null) customMarks[`${gadgetMark.name}-duration`] = gadgetMark.end - gadgetMark.start;
        });
        const gadgetLoadIdentifier = `gadget-${context.current.dashboardId ?? 'no-dashboard-id'}-${gadgetId}`;
        (0, $dFjTU.gadgetLoad)(gadgetLoadIdentifier).start({
            startTime: context.current.navStart
        });
        (0, $dFjTU.gadgetLoad)(gadgetLoadIdentifier).stop({
            customData: customMarks,
            stopTime: Date.now()
        });
        if (gadgetEventRecord.source === (0, $kF6iw.WRM_GADGET_METRICS) && gadgetEventRecord.contentType !== 'View' && gadgetEventRecord.contentType !== 'Config') (0, $9lmTX.default)({
            ...$9d91f5788035531f$var$expAttributes,
            experience: (0, $kEBPk.VIEW_WRM_GADGET_EXPERIENCE),
            wasExperienceSuccesful: false
        });
    }, []);
    const sendOverallGadgetMetrics = (0, $eUqFw.useCallback)((gadgetIds, gadgetMetricsEvents, timeout)=>{
        const metricToReport = {
            timeout: timeout,
            fullDashboardTTI: Date.now() - Number(context.current.navStart),
            dashboardScrollStartTime: context.current.scrollStartTimestamp.current != null ? context.current.scrollStartTimestamp.current - Number(context.current.navStart) : 'unknown',
            belowTheFoldTTI: Date.now() - (context.current.scrollStartTimestamp.current != null && (context.current.gadgets?.length || 0) - context.current.aboveTheFoldGadgets.size > 0 ? context.current.scrollStartTimestamp.current : Date.now())
        };
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fullDashboard loaded', metricToReport);
    }, [
        createAnalyticsEvent
    ]);
    const onAboveTheFoldGadgetsRender = (0, $eUqFw.useCallback)((gadgetIds, gadgetMetricsEvents, gadgetRenderStartTime, contextTimeStamps, timeout)=>{
        // count connect gadgets
        const connectGadgetCount = context.current.gadgets?.filter((item)=>(0, $kF6iw.CONNECT_MODULE_PATTERN).test(item.amdModule || '')).length || 0;
        // count forge gadgets
        const forgeGadgetCount = context.current.gadgets?.filter((item)=>(0, $kF6iw.FORGE_MODULE_PATTERN).test(item.forge?.key || '')).length || 0;
        // count untracked gadgets (including connect)
        const untrackedGadgetCount = context.current.gadgets?.filter((item)=>gadgetIds.every((id)=>id !== item.id)).length || 0;
        const initialMarks = $9d91f5788035531f$var$getInitialMarks(context.current);
        const gadgetRenderStart = gadgetRenderStartTime - Number(context.current.navStart);
        // Validate metrics context
        const invalidContextState = $9d91f5788035531f$var$isInvalidContextState(contextTimeStamps, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        context.current.navStart, context.current.currentPageId) || initialMarks.TTI < 0 || gadgetRenderStart < 0;
        if (invalidContextState) // Report abnormal status
        (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics context state is invalid for dashboard [${context.current.currentPageId ?? 'null'}]: { contextTimestamps: ${JSON?.stringify(contextTimeStamps)}, now:${Date.now()}, pnow:${performance?.now()}, navStart:${context.current.navStart} }`);
        const customData = {
            ...initialMarks,
            gadgetRenderStart: gadgetRenderStart,
            // counts
            gadgetCount_Total: context.current.gadgets?.length ?? 0,
            gadgetCount_Connect: connectGadgetCount,
            gadgetCount_Forge: forgeGadgetCount,
            gadgetCount_Unknown: untrackedGadgetCount - connectGadgetCount,
            timeout: timeout,
            gadgetCount_AboveTheFold: context.current.aboveTheFoldGadgets.size,
            isStaled: invalidContextState
        };
        (0, $1QVWH.addUFOCustomData)(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $45wsB.trackBM3FeatureFlagsAccessed)((0, $dFjTU.dashboardLoad));
        (0, $fVaJL.addApdexToAll)({
            key: (0, $dFjTU.dashboardLoad).key,
            stopTime: performance.now()
        });
        if ((0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences')) (0, $lMwBY.afterPaintEmit)((stopTime)=>{
            (0, $dFjTU.dashboardLoad).stop({
                stopTime: stopTime,
                customData: // @ts-expect-error - feature flags may technically be null which BM3 doesn't like
                customData
            });
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $dFjTU.dashboardLoad));
        else (0, $dFjTU.dashboardLoad).stop({
            customData: // @ts-expect-error - feature flags may technically be null which BM3 doesn't like
            customData
        });
    }, []);
    const resetScrollStartMetrics = (0, $eUqFw.useCallback)(()=>{
        context.current.resetScrollStartTime();
    }, []);
    const sendDebuggingAnalytics = (0, $eUqFw.useCallback)((contextTimeStamps)=>{
        const attributes = {
            isStale: $9d91f5788035531f$var$isInvalidContextState(contextTimeStamps, context.current.navStart, context.current.currentPageId),
            tti: Date.now() - Number(context.current.navStart),
            currentPageId: context.current.currentPageId
        };
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'tti sent', attributes);
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendGadgetMetrics: sendGadgetMetrics,
        sendOverallGadgetMetrics: sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender,
        resetScrollStartMetrics: resetScrollStartMetrics,
        sendDebuggingAnalytics: sendDebuggingAnalytics
    };
};

});
parcelRegister("lMwBY", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $6a5d9a384a9292d0$export$dc4c3408669b8f4e);

var $6iz4v = parcelRequire("6iz4v");

const $6a5d9a384a9292d0$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});

parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("dFjTU", function(module, exports) {

$parcel$export(module.exports, "gadgetLoad", () => $0bf04dd1209b86cc$export$4de73f6aec94634c);
$parcel$export(module.exports, "dashboardLoad", () => $0bf04dd1209b86cc$export$2b2c4cbb9844d8cb);

var $lNfG4 = parcelRequire("lNfG4");
const $0bf04dd1209b86cc$export$4de73f6aec94634c = (0, $lNfG4.metrics).concurrent.custom({
    key: 'dashboard.gadget',
    featureFlags: []
});
const $0bf04dd1209b86cc$export$2b2c4cbb9844d8cb = (0, $lNfG4.metrics).pageLoad({
    key: 'dashboard',
    featureFlags: []
});

});

parcelRegister("ces19", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureFlags", () => $641759a5eceae85c$export$5f260d38da0c0462);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $5iWql = parcelRequire("5iWql");

var $aWbzA = parcelRequire("aWbzA");
// IMPORTANT - endeavour dashboard flags should match schema, this is primarily for other teams FFs
const $641759a5eceae85c$var$DASHBOARD_ADDITIONAL_FLAGS = [];
const $641759a5eceae85c$var$DASHBOARD_FEATURE_FLAG_SCHEMA = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
const $641759a5eceae85c$export$5f260d38da0c0462 = (0, $5iWql.default)(()=>{
    // at time of writing getFeatureFlags() will throw for badly formed feature flag JSON
    try {
        const allFFs = (0, $aWbzA.default)() || {};
        return Object.fromEntries(Object.keys(allFFs).filter((key)=>$641759a5eceae85c$var$DASHBOARD_FEATURE_FLAG_SCHEMA.test(key) || $641759a5eceae85c$var$DASHBOARD_ADDITIONAL_FLAGS.includes(key)).sort((a, b)=>a.localeCompare(b, undefined, {
                ignorePunctuation: true
            })).map((key)=>[
                key,
                allFFs[key].value
            ]));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});

});

parcelRegister("rekMK", function(module, exports) {

$parcel$export(module.exports, "useDashboardScrollAnalytics", () => $d0f187c09c826dfa$export$83af525d5e7538fa);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8WKBq = parcelRequire("8WKBq");
var $78d1w = parcelRequire("78d1w");
const $d0f187c09c826dfa$export$83af525d5e7538fa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const currentPage = (0, $8WKBq.useCurrentPage)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { startTime: startTime } = currentPage;
    const scrollStartTimestamp = (0, $eUqFw.useRef)(null);
    const debounceSendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((_scrollStartTimestamp)=>{
        if (scrollStartTimestamp.current != null) return;
        const percentageOfPageScrolled = window.scrollY / window.innerHeight;
        if (percentageOfPageScrolled < 0.2) return;
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'scrolled',
            actionSubject: 'page'
        }), 'dashboardScroll', {
            isInitialRender: isInitialRender,
            scrollStartTimeFromPageLoad: _scrollStartTimestamp - startTime,
            percentageOfPageScrolled: percentageOfPageScrolled,
            currentPageId: currentPageId
        });
        scrollStartTimestamp.current = _scrollStartTimestamp;
    }, 500);
    (0, $eUqFw.useEffect)(()=>{
        const fireScrollAnalytics = ()=>{
            debounceSendAnalytics(Date.now());
        };
        const resetScrollPosition = ()=>{
            window.scrollTo(0, 0);
        };
        window.addEventListener('scroll', fireScrollAnalytics);
        window.addEventListener('unload', resetScrollPosition);
        return ()=>{
            window.removeEventListener('scroll', fireScrollAnalytics);
            window.removeEventListener('unload', resetScrollPosition);
        };
    }, [
        debounceSendAnalytics
    ]);
    const resetScrollStartTime = (0, $eUqFw.useCallback)(()=>{
        scrollStartTimestamp.current = null;
    }, []);
    return {
        scrollStartTimestamp: scrollStartTimestamp,
        resetScrollStartTime: resetScrollStartTime
    };
};

});
parcelRegister("8WKBq", function(module, exports) {

$parcel$export(module.exports, "useCurrentPage", () => $319deecc32e62352$export$6faff8ed5e305ed3);

var $ggKAj = parcelRequire("ggKAj");

var $cfLkw = parcelRequire("cfLkw");
const $319deecc32e62352$var$useSweetStateCurrentPage = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: (state)=>state.currentPage
});
const $319deecc32e62352$export$6faff8ed5e305ed3 = ()=>{
    const [currentPage] = $319deecc32e62352$var$useSweetStateCurrentPage();
    return currentPage;
};

});



parcelRegister("6ofMt", function(module, exports) {

$parcel$export(module.exports, "GADGETS_TO_REPORT", () => $7c2aafc47116614f$export$2c28b0760818db72);
$parcel$export(module.exports, "GADGETS_IGNORED", () => $7c2aafc47116614f$export$c1d730ac3dcf5785);
// A list of gadgets (gadgetType) should contribute to the overall dashboard TTI.
// Some gadgets not in this list may not send metrics event to the dashboard and potentially hold up the dashboard
// metrics until 60 second timeout.
const $7c2aafc47116614f$export$2c28b0760818db72 = new Set([
    // WRM gadgets
    'jira-dashboard-items/assigned-to-me',
    'jira-dashboard-items/bubble-chart-dashboard-item',
    'jira-dashboard-items/createdvsresolved',
    'jira-dashboard-items/favourite-filters',
    'jira-dashboard-items/filter-results',
    'jira-dashboard-items/in-progress',
    'jira-dashboard-items/labels',
    'jira-dashboard-items/piechart',
    'jira-dashboard-items/stats',
    'jira-dashboard-items/two-dimensional-stats',
    'jira-dashboard-items/voted',
    'jira-dashboard-items/watched',
    'jira-dashboard-items/issuescalendar',
    'jira-dashboard-items/projects',
    'jira-dashboard-items/activitystream',
    'jira-dashboard-items/recently-created',
    'jira-dashboard-items/workload-pie-chart',
    'jira-dashboard-items/roadmap',
    'jira-dashboard-items/average-age-chart',
    'jira-dashboard-items/average-time-in-status-chart',
    'jira-dashboard-items/average-number-of-times-in-status-chart',
    'jira-dashboard-items/heat-map',
    'jira-dashboard-items/time-to-first-response',
    'jira-dashboard-items/sprint-burndown',
    'jira-dashboard-items/resolution-time',
    'jira-dashboard-items/timesince',
    'jira-dashboard-items/spacer',
    'jira-dashboard-items/rapid-view',
    'jira-dashboard-items/version-report',
    // simple iframe gadgets
    'rest/gadgets/1.0/g/com.atlassian.bonfire.plugin:bonfire-test-sessions-gadget/gadget/bonfire-sessions-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.calendar:issuescalendar-gadget/templates/plugins/jira/portlets/calendar/gadget/calendar-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:firstresponse-gadget/com/atlassian/jira/ext/charting/gadget/firstresponse-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:numberoftimesinstatus-gadget/com/atlassian/jira/ext/charting/gadget/numberoftimesinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:timeinstatus-gadget/com/atlassian/jira/ext/charting/gadget/timeinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:workloadpie-gadget/com/atlassian/jira/ext/charting/gadget/workloadpie-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:average-age-chart-gadget/gadgets/average-age-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:recently-created-chart-gadget/gadgets/recently-created-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:resolution-time-gadget/gadgets/resolution-time-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:time-since-chart-gadget/gadgets/timesince-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:crucible-charting-gadget/gadgets/crucible-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-charting-gadget/gadgets/fisheye-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-recent-commits-gadget/gadgets/fisheye-recent-commits-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirawallboard.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.streams.streams-jira-plugin:activitystream-gadget/gadgets/activitystream-gadget.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-rapid-view/gadgets/greenhopper-rapid-view.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-burndown/gadgets/greenhopper-sprint-burndown.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-version-report/gadgets/greenhopper-version-report.xml'
]);
const $7c2aafc47116614f$export$c1d730ac3dcf5785 = new Set([
    'jira-dashboard-items/sprint-days-remaining',
    'jira-dashboard-items/sprint-health',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item'
]);

});


parcelRegister("9zcCd", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $a256b88f7680f175$export$ea2491906b753456);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");

var $kEBPk = parcelRequire("kEBPk");

var $01Qi5 = parcelRequire("01Qi5");

var $lcJyp = parcelRequire("lcJyp");

var $iKzwQ = parcelRequire("iKzwQ");
const $a256b88f7680f175$var$isAmdGadget = (gadget)=>gadget.amdModule != null && gadget.amdModule !== (0, $kEBPk.CONNECT_ITEM_AMD_MODULE);
const $a256b88f7680f175$var$isWaitableGadget = (gadget)=>$a256b88f7680f175$var$isAmdGadget(gadget);
const $a256b88f7680f175$var$getWaitableGadgetSet = (gadgets)=>new Set(gadgets.filter($a256b88f7680f175$var$isWaitableGadget).map(({ id: id })=>id));
const $a256b88f7680f175$export$ea2491906b753456 = ()=>{
    const { data: data, loading: loading } = (0, $01Qi5.useDashboardResource)();
    const [, { registerListener: registerListener, unregisterListener: unregisterListener }] = (0, $iKzwQ.useMessageBus)();
    const lastDashboardId = (0, $eUqFw.useRef)();
    const pendingGadgetSet = (0, $eUqFw.useRef)(new Set());
    const [, { setAppReady: setAppReady }] = (0, $lcJyp.useSpaStateActions)();
    const callback = (0, $eUqFw.useCallback)((type, _, { gadgetId: gadgetId })=>{
        if (type !== (0, $kEBPk.GADGET_METRICS_TYPE).REPORT) return;
        if (!pendingGadgetSet.current.has(gadgetId)) return;
        pendingGadgetSet.current.delete(gadgetId);
        if (pendingGadgetSet.current.size > 0) return;
        unregisterListener(callback);
        (0, $6iz4v.setMark)((0, $kEBPk.PAGE_READY_METRIC_KEY));
        setAppReady();
    }, [
        setAppReady,
        unregisterListener
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (loading || data == null || data.id === lastDashboardId.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        lastDashboardId.current = data.id;
        pendingGadgetSet.current = $a256b88f7680f175$var$getWaitableGadgetSet(data.gadgets);
        if (pendingGadgetSet.current.size === 0) {
            (0, $6iz4v.setMark)((0, $kEBPk.PAGE_READY_METRIC_KEY));
            setAppReady();
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        registerListener(callback);
        return ()=>{
            unregisterListener(callback);
        };
    }, [
        callback,
        data,
        loading,
        registerListener,
        setAppReady,
        unregisterListener
    ]);
};

});

parcelRegister("1xFgW", function(module, exports) {

$parcel$export(module.exports, "addDashboardToRecents", () => $55631ac2a21d6cbc$export$9f034829a82f8a11);
const $55631ac2a21d6cbc$export$9f034829a82f8a11 = (dashboardId)=>fetch(`/rest/internal/latest/dashboards/history/${dashboardId}`, {
        method: 'POST'
    });

});

parcelRegister("kVRTc", function(module, exports) {

$parcel$export(module.exports, "AboveTheFoldContainer", () => $2209e0d5e3e20178$export$60c1d52f3e30a1cd);

var $eUqFw = parcelRequire("eUqFw");

var $179bk = parcelRequire("179bk");

var $aIeBA = parcelRequire("aIeBA");
const $2209e0d5e3e20178$export$60c1d52f3e30a1cd = ({ gadgets: gadgets, dashboardId: dashboardId, layout: layout, children: children })=>{
    const columns = (0, $eUqFw.useMemo)(()=>(0, $aIeBA.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $179bk.RenderAboveTheFoldContainer), {
        columns: columns,
        dashboardId: dashboardId,
        scope: dashboardId
    }, children);
};

});

parcelRegister("4Jf8r", function(module, exports) {

$parcel$export(module.exports, "AmdGadgetMonolithOverrideStyles", () => $c8f679d6c3022720$export$17921465e6f60e58);

var $eUqFw = parcelRequire("eUqFw");
const $c8f679d6c3022720$var$styles = `.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #5e6c84)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #0049b0)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #ebecf0)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #172b4d)"};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #5e6c84)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0049b0)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: 400;
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $c8f679d6c3022720$export$17921465e6f60e58 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, $c8f679d6c3022720$var$styles);

});

parcelRegister("3kpkG", function(module, exports) {

$parcel$export(module.exports, "DASHBOARD_PERMISSION_ERROR_CODE_LIST", () => $8c42a2e3550fad75$export$f33202be19a062b9);
// NOTE: Avoid modifying code `401` as this is used by wallboard and permission error pages (search DASHBOARD_PERMISSION_ERROR_CODE_LIST for usages).
// Wallboard does not reference this list directly because there are import issues, so it uses `401` as a string.
const $8c42a2e3550fad75$export$f33202be19a062b9 = [
    401,
    403,
    404
];

});

parcelRegister("35TBS", function(module, exports) {

$parcel$export(module.exports, "usePageStatusLogger", () => $0a94d34d8f3d0493$export$8b3b053e4f10e669);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");


var $78d1w = parcelRequire("78d1w");

var $dYru8 = parcelRequire("dYru8");

var $ces19 = parcelRequire("ces19");
const $0a94d34d8f3d0493$var$TEN_MIN = 600000;
// We need to replace '.' in FF keys with '_' to match BM3 and avoid confusion in Splunk
const $0a94d34d8f3d0493$var$sanitiseKeys = (featureFlags)=>Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(featureFlags || {}).map(([key, value])=>[
            key.replace(/\./g, '_'),
            value
        ]));
const $0a94d34d8f3d0493$export$8b3b053e4f10e669 = (interval)=>{
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId, lastTransition: lastTransition }] = (0, $78d1w.useSpaStateTransition)();
    (0, $eUqFw.useEffect)(()=>{
        const logFeatureFlags = ()=>{
            const featureFlags = JSON.stringify($0a94d34d8f3d0493$var$sanitiseKeys((0, $ces19.getDashboardFeatureFlags)()));
            const attributes = {
                isInitialRender: isInitialRender,
                lastTransition: lastTransition,
                currentPageId: currentPageId,
                featureFlags: featureFlags
            };
            (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.page-status', Object.entries(attributes) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([k, v])=>`${k} [${String(v ?? null)}]`).join(' '));
            fireAnalytics({
                eventType: (0, $41ea3621645e2acc$export$12346a674644c156),
                actionSubject: 'dashboard.page-status',
                actionSubjectId: 'featureFlags',
                action: 'logged',
                attributes: attributes
            });
        };
        logFeatureFlags();
        const logInterval = setInterval(logFeatureFlags, Math.max($0a94d34d8f3d0493$var$TEN_MIN, interval) || $0a94d34d8f3d0493$var$TEN_MIN);
        return ()=>clearInterval(logInterval);
    }, [
        interval,
        fireAnalytics,
        isInitialRender,
        currentPageId,
        lastTransition
    ]);
};

});

parcelRegister("b4XFG", function(module, exports) {

$parcel$export(module.exports, "RouteResourceValidator", () => $e62eebd9982c76c8$export$1d8835c03b47dfbd);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");
const $e62eebd9982c76c8$export$1d8835c03b47dfbd = ()=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const { promise: promise, loading: loading, data: data, error: error } = (0, $01Qi5.useDashboardAMDModulesResource)();
    const [hasRendered, setHasRendered] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!loading) setHasRendered(true);
    }, [
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (false) return;
        const prefix = `Resource validation [${isInitialRender ? 'initial' : 'transition'}][${hasRendered ? 'rerender' : 'original'}]`;
        if (!promise) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource may be missing`);
        else if (loading) (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} loading`);
        else if (data) {
            const { amdModules: amdModules, sharedValue: sharedValue } = data;
            if (sharedValue == null || sharedValue instanceof Error) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource shared value [${String(sharedValue)}]`);
            else if (!sharedValue?.isPreloaded && isInitialRender && !hasRendered) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, config+wrm resource did not run in SSR`);
            else if (amdModules === null) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, WRM resources failed to load`);
            else {
                const [failedCount, totalCount] = Object.values(amdModules).reduce(([f], v, i, arr)=>[
                        f + (v == null ? 1 : 0),
                        arr.length
                    ], [
                    0,
                    0
                ]);
                if (failedCount > 0) {
                    const failedNames = Object.entries(amdModules).filter(([, v])=>v == null).map(([k])=>k).join(',');
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD evaluation failed [${failedCount}] of [${totalCount}], failed modules [${failedNames}]`);
                } else (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} success`);
            }
        } else if (error) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed with AMD resource error [${error instanceof Error ? error.message : String(error)}]`, error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promise,
        loading,
        data,
        error
    ]);
    return null;
};

});


parcelRegister("jOV2f", function(module, exports) {

$parcel$export(module.exports, "DashboardController", () => $0c5cabd78de58446$export$b9771780c6ecf3f);

var $eUqFw = parcelRequire("eUqFw");

var $4J7Iv = parcelRequire("4J7Iv");

var $dnhZn = parcelRequire("dnhZn");

var $kEBPk = parcelRequire("kEBPk");

var $lIqKj = parcelRequire("lIqKj");
const $0c5cabd78de58446$export$d7eb50fb85f631d = ({ automaticRefreshMs: automaticRefreshMs })=>{
    const [refreshId, setRefreshId] = (0, $eUqFw.useState)(Date.now());
    const [, setMostRecentlyAddedGadgetId] = (0, $eUqFw.useState)(null);
    const onRefresh = (0, $eUqFw.useCallback)(()=>{
        (0, $4J7Iv.emit)((0, $kEBPk.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), {
            origin: 'dashboard'
        });
        (0, $dnhZn.default)((0, $kEBPk.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {}, {
            origin: 'dashboard'
        });
        setRefreshId(Date.now());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs < 1) return ()=>undefined;
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    const onMount = (0, $eUqFw.useCallback)((gadgetId, focusCallback)=>{
        setMostRecentlyAddedGadgetId((mostRecentlyAddedGadgetId)=>{
            if (gadgetId === mostRecentlyAddedGadgetId) {
                focusCallback();
                return null;
            }
            return mostRecentlyAddedGadgetId;
        });
    }, []);
    return {
        onRefresh: onRefresh,
        refreshId: refreshId,
        onAddedGadget: setMostRecentlyAddedGadgetId,
        onMount: onMount
    };
};
const $0c5cabd78de58446$export$b9771780c6ecf3f = ({ children: children, ...props })=>{
    const value = $0c5cabd78de58446$export$d7eb50fb85f631d(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIqKj.DashboardControllerContextProvider), {
        value: value
    }, children);
};

});
parcelRegister("4J7Iv", function(module, exports) {

$parcel$export(module.exports, "on", () => $91990798a71bcb39$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $91990798a71bcb39$export$8f35fbd5db0f3634);
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $91990798a71bcb39$var$EVENT_PREFIX = 'forge.bridge.';
function $91990798a71bcb39$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$91990798a71bcb39$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$91990798a71bcb39$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $91990798a71bcb39$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$91990798a71bcb39$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});

parcelRegister("dnhZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fad4fd9e63464a6$export$2e2bcd8739ae039);

var $4lxPQ = parcelRequire("4lxPQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fad4fd9e63464a6$export$2e2bcd8739ae039 = (eventName, addonFilter, eventData)=>{
    (0, $4lxPQ.withConnectHost)((host)=>{
        host && host.broadcastEvent(eventName, addonFilter, eventData);
    });
};

});
parcelRegister("4lxPQ", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $74a29a4beb89f78b$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $74a29a4beb89f78b$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $74a29a4beb89f78b$export$920fb4b46d4f2eec);

var $3X4Tl = parcelRequire("3X4Tl");
const $74a29a4beb89f78b$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $3X4Tl.setupConnectJs)();
    action(connectHost);
};
const $74a29a4beb89f78b$export$186d423c00af146c = ()=>window.connectHost;
const $74a29a4beb89f78b$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("3X4Tl", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $e1d87b293e6b1fa3$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $8nDwh = parcelRequire("8nDwh");

const $e1d87b293e6b1fa3$var$installConnectJs = async ()=>{
    await (0, $8nDwh.waitForJQuery)();
    const loader = await (parcelRequire("ds7fh"));
    await loader.performSideEffects();
    return window.connectHost;
};
let $e1d87b293e6b1fa3$var$installConnectJsPromise = null;
const $e1d87b293e6b1fa3$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    if (window.__SPA__) {
        if ($e1d87b293e6b1fa3$var$installConnectJsPromise === null) $e1d87b293e6b1fa3$var$installConnectJsPromise = $e1d87b293e6b1fa3$var$installConnectJs();
        return $e1d87b293e6b1fa3$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $2BvS3.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    return window.connectHost;
};

});
parcelRegister("8nDwh", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $57c59c350a2284e3$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $57c59c350a2284e3$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $57c59c350a2284e3$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $57c59c350a2284e3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $57c59c350a2284e3$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $57c59c350a2284e3$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $57c59c350a2284e3$export$d690da9bc8146677);

var $guiFP = parcelRequire("guiFP");

var $8n8Xw = parcelRequire("8n8Xw");
const $57c59c350a2284e3$export$c47913ca32a5c6f7 = (key)=>{
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $57c59c350a2284e3$export$7232a6dc780f9887 = ()=>AJS.$;
const $57c59c350a2284e3$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    window._AP;
const $57c59c350a2284e3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $57c59c350a2284e3$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $57c59c350a2284e3$var$FIVE_MINUTES = 300000;
const $57c59c350a2284e3$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $guiFP.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $57c59c350a2284e3$var$FIVE_MINUTES);
    });
const $57c59c350a2284e3$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $57c59c350a2284e3$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $57c59c350a2284e3$export$d690da9bc8146677 = [
    $57c59c350a2284e3$export$cb954c21735b28e4,
    $57c59c350a2284e3$export$7315c38dc71bd41f
];

});
parcelRegister("8n8Xw", function(module, exports) {

$parcel$export(module.exports, "FetchConnectError", () => $54c275f50bd3d999$export$630f7f9a7ae923d1);
$parcel$export(module.exports, "handleConnectError", () => $54c275f50bd3d999$export$a7a3f8c4788fb03d);

var $guiFP = parcelRequire("guiFP");

var $lgAsZ = parcelRequire("lgAsZ");
function $54c275f50bd3d999$var$is4xxError(statusCode) {
    return statusCode ? statusCode >= 400 && statusCode < 500 : false;
}
class $54c275f50bd3d999$export$630f7f9a7ae923d1 extends (0, $lgAsZ.default) {
    constructor(message, statusCode, cause, skipSentry){
        super(message, {
            cause: cause
        });
        // the name is copied from `KNOWN_NETWORK_ERRORS_TYPES` in `src/packages/platform/utils/fetch/src/utils/is-error.tsx`
        this.name = cause && cause.name ? cause.name : 'NetworkError';
        this.statusCode = statusCode;
        this.skipSentry = typeof skipSentry === 'boolean' ? skipSentry : $54c275f50bd3d999$var$is4xxError(statusCode);
    }
}
const $54c275f50bd3d999$export$a7a3f8c4788fb03d = (id, error, errorAttrs = {})=>{
    const options = {
        error: error,
        meta: {
            id: id,
            packageName: 'jiraConnect'
        },
        attributes: {
            skipSentry: error.skipSentry,
            statusCode: error.statusCode,
            ...errorAttrs
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: error.skipSentry
    };
    (0, $guiFP.default)(options);
    if (error.cause) (0, $guiFP.default)({
        ...options,
        attributes: {
            ...options.attributes,
            isInnerError: true
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error: error.cause
    });
};

});


parcelRegister("ds7fh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dJtVb');
        const value = parcelRequire('l6TcI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dJtVb").then(()=>parcelRequire('l6TcI'));
}

});




parcelRegister("lIqKj", function(module, exports) {

$parcel$export(module.exports, "DashboardControllerContextProvider", () => $88d721fcbd4febd2$export$36eb228a17cae64d);
$parcel$export(module.exports, "DashboardControllerContextConsumer", () => $88d721fcbd4febd2$export$4ce01c0dbab5bb18);
$parcel$export(module.exports, "useDashboardRefresh", () => $88d721fcbd4febd2$export$71d14892f68b2430);
$parcel$export(module.exports, "useOnAddedGadget", () => $88d721fcbd4febd2$export$2471f3ee3e3601fe);

var $4klDo = parcelRequire("4klDo");
const { createUseContextField: $88d721fcbd4febd2$export$3fb47a2904db1f37, Provider: $88d721fcbd4febd2$export$36eb228a17cae64d, Consumer: $88d721fcbd4febd2$export$4ce01c0dbab5bb18 } = (0, $4klDo.createRendererContext)();
const $88d721fcbd4febd2$export$71d14892f68b2430 = $88d721fcbd4febd2$export$3fb47a2904db1f37('onRefresh');
const $88d721fcbd4febd2$export$2471f3ee3e3601fe = $88d721fcbd4febd2$export$3fb47a2904db1f37('onAddedGadget');

});
parcelRegister("4klDo", function(module, exports) {

$parcel$export(module.exports, "createRendererContext", () => $3433cfc1c4724813$export$ac09db0e74937f7f);

var $eUqFw = parcelRequire("eUqFw");

var $aFvYX = parcelRequire("aFvYX");
const $3433cfc1c4724813$export$ac09db0e74937f7f = ()=>{
    const _UnmemoisedContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { Provider: UnmemoisedProvider, Consumer: Consumer } = _UnmemoisedContext;
    const Provider = /*#__PURE__*/ (0, $eUqFw.memo)(UnmemoisedProvider, ({ value: valueA, ...propsA }, { value: valueB, ...propsB })=>(0, $aFvYX.default)(valueA, valueB) && (0, $aFvYX.default)(propsA, propsB));
    const createRenderFunction = (children)=>(value)=>children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Provider, {
                value: value
            }, typeof children === 'function' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Consumer, null, children) : children) : null;
    const createUseContextField = (key)=>()=>{
            const value = (0, $eUqFw.useContext)(_UnmemoisedContext);
            if (value == null) throw new Error('context not found');
            return value[key];
        };
    return {
        _UnmemoisedContext: _UnmemoisedContext,
        Provider: Provider,
        Consumer: Consumer,
        createRenderFunction: createRenderFunction,
        createUseContextField: createUseContextField
    };
};

});
parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});





parcelRegister("244wN", function(module, exports) {

$parcel$export(module.exports, "DashboardPageContainer", () => $ba93b869131c0227$export$8aeaeff803e753cd);

var $eUqFw = parcelRequire("eUqFw");

var $9EHc8 = parcelRequire("9EHc8");

var $heNSb = parcelRequire("heNSb");

var $8WuJm = parcelRequire("8WuJm");

var $fO5rB = parcelRequire("fO5rB");

var $44MKD = parcelRequire("44MKD");

var $78d1w = parcelRequire("78d1w");

var $gd0Sp = parcelRequire("gd0Sp");

var $lxLTd = parcelRequire("lxLTd");

var $gOA4E = parcelRequire("gOA4E");

var $id3p3 = parcelRequire("id3p3");
const $ba93b869131c0227$export$8aeaeff803e753cd = ({ children: children, analyticsSourceName: analyticsSourceName, analyticsExperience: analyticsExperience, unauthenticatedFallback: unauthenticatedFallback, unauthorisedFallback: unauthorisedFallback, documentTitle: documentTitle, resourceData: resourceData })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: data, loading: loading } = resourceData;
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const ref = (0, $gOA4E.useDashboardRef)();
    if (!tenantContext) return null;
    if (!tenantContext.atlassianAccountId && !loading && !data) return unauthenticatedFallback;
    if (unauthorisedFallback != null && data && !data.writable) return unauthorisedFallback;
    /**
	 * we need to also mark this with the 'dashboardScreen' analytics source.
	 * Otherwise, the source will default to 'navigationNextScreen'.
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44MKD.OnboardingCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: analyticsSourceName,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        containerId: data?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "platform"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $id3p3.PageLayout), {
        ref: ref
    }, !isInitialRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxLTd.PrefetchLinks), {
        dashboardId: data?.id ?? 'pending'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "dashboard",
        // Need className for some of some gadgets, e.g. Filter Count
        // Please always make sure the wrapper dom id and class are in the html response
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "dashboard",
        "data-testid": "dashboard-internal-common.ui.container.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experienceId: data?.id,
        experience: analyticsExperience,
        analyticsSource: "dashboard",
        edition: null,
        application: null
    }, children)))));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("44MKD", function(module, exports) {

$parcel$export(module.exports, "OnboardingCheck", () => $28385f28cac806e5$export$63497c970048803c);

var $eUqFw = parcelRequire("eUqFw");

var $ae4LH = parcelRequire("ae4LH");

var $gUUjF = parcelRequire("gUUjF");

var $jkWSB = parcelRequire("jkWSB");

var $kJlBc = parcelRequire("kJlBc");
const $28385f28cac806e5$var$LOCATION = 'onboarding-check';
const $28385f28cac806e5$var$FireUsageAnalytics = ({ url: url })=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $gUUjF.default).safeInfoWithoutCustomerData($28385f28cac806e5$var$LOCATION, `User was redirected to onboarding url ${url}`);
    }, [
        url
    ]);
    return null;
};
const $28385f28cac806e5$export$63497c970048803c = ({ shouldLogUsage: shouldLogUsage, children: children })=>!false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkWSB.MetaAPIConsumer), null, (getMeta)=>{
        const meta = getMeta('ajs-onboarding-url');
        if (meta != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldLogUsage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28385f28cac806e5$var$FireUsageAnalytics, {
            url: meta
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: meta
        }));
        return children;
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});
parcelRegister("jkWSB", function(module, exports) {

$parcel$export(module.exports, "MetaAPIConsumer", () => $63ce08ffb5bc96ef$export$8b3f3b109d67f2a);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");
/**
 * Provide `getMeta(...)` via context.
 */ const $63ce08ffb5bc96ef$var$MetaAPIContext = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $6rW04.default));
const { Provider: $63ce08ffb5bc96ef$export$ab3e6458d0544c37, Consumer: $63ce08ffb5bc96ef$export$8b3f3b109d67f2a } = $63ce08ffb5bc96ef$var$MetaAPIContext;
const $63ce08ffb5bc96ef$export$42954e2090da65e = ()=>(0, $eUqFw.useContext)($63ce08ffb5bc96ef$var$MetaAPIContext);

});


parcelRegister("lxLTd", function(module, exports) {

$parcel$export(module.exports, "PrefetchLinks", () => $80b2dd579213799b$export$b64797ad00b7bd3c);

var $eUqFw = parcelRequire("eUqFw");

var $829dv = parcelRequire("829dv");
var $kEBPk = parcelRequire("kEBPk");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");
const $80b2dd579213799b$export$b64797ad00b7bd3c = ({ dashboardId: dashboardId })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const { data: data } = (0, $01Qi5.useDashboardResource)();
    const prefetches = (0, $eUqFw.useMemo)(()=>data ? (0, $829dv.getPrefetches)(data) : [], [
        data
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!isInitialRender && window && window[0, $kEBPk.PRELOADED_GADGET_DATA_KEY]) // cleanup preloaded data on window, which is only used on initial load
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        delete window[0, $kEBPk.PRELOADED_GADGET_DATA_KEY];
    }, [
        isInitialRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, prefetches.map((prefetch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("link", {
            key: `${dashboardId}-${prefetch.url}`,
            rel: isInitialRender ? prefetch.priority : 'prefetch',
            as: "fetch",
            href: prefetch.url
        })));
};

});

parcelRegister("gOA4E", function(module, exports) {

$parcel$export(module.exports, "useDashboardRef", () => $a1b9be0d5aa3752e$export$a52b4118d451e93c);

var $eUqFw = parcelRequire("eUqFw");
const $a1b9be0d5aa3752e$export$a52b4118d451e93c = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        const originalGetDashboard = window.AG?.DashboardManager?.getDashboard;
        return ()=>{
            window.AG = {
                ...window.AG,
                DashboardManager: {
                    ...window.AG?.DashboardManager,
                    getDashboard: originalGetDashboard
                }
            };
        };
    }, []);
    return (0, $eUqFw.useCallback)((node)=>{
        window.AG = {
            ...window.AG,
            DashboardManager: {
                ...window.AG?.DashboardManager,
                getDashboard: ()=>node
            }
        };
    }, []);
};

});

parcelRegister("id3p3", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d3d8d6e38ee89bc$export$6d1402fb58384e4f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3d3d8d6e38ee89bc$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zdiv _kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hOodT", function(module, exports) {

$parcel$export(module.exports, "getColumnWidth", () => $d8cef97bce94b94c$export$dfa11a34ceba822);

var $kEBPk = parcelRequire("kEBPk");
const $d8cef97bce94b94c$export$dfa11a34ceba822 = (index, layout, display)=>{
    if (display === (0, $kEBPk.GADGET_DISPLAY).HIDDEN) return 0;
    if (layout === 'A' || display === (0, $kEBPk.GADGET_DISPLAY).MAXIMIZED) return 12;
    if (layout === 'AA') return 6;
    if (layout === 'AAA') return 4;
    if (layout === 'AB') return index === 0 ? 8 : 4;
    return index === 0 ? 4 : 8;
};

});

parcelRegister("f9MgH", function(module, exports) {

$parcel$export(module.exports, "useGadgetTitle", () => $f47ce2e2be077c91$export$dba832fc7432cba1);
$parcel$export(module.exports, "useConnectGadgetTitles", () => $f47ce2e2be077c91$export$66e677fcbdac9c95);

var $eUqFw = parcelRequire("eUqFw");
function $f47ce2e2be077c91$export$dba832fc7432cba1({ defaultTitle: initialDefaultTitle, title: title, onSave: onSave }) {
    const [defaultTitle, setDefaultTitle] = (0, $eUqFw.useState)(initialDefaultTitle);
    const [userTitle, setUserTitle] = (0, $eUqFw.useState)(title);
    const setTitle = (0, $eUqFw.useCallback)(async (newTitle)=>{
        const previousTitle = userTitle;
        setUserTitle(newTitle);
        onSave?.(newTitle).catch(()=>{
            setUserTitle(previousTitle);
        });
    }, [
        userTitle,
        onSave
    ]);
    const setDefaultTitleWithInitialTitle = (0, $eUqFw.useCallback)((defaultTitleUpdaterOrValue)=>{
        setDefaultTitle(typeof defaultTitleUpdaterOrValue === 'function' ? defaultTitleUpdaterOrValue(initialDefaultTitle) : defaultTitleUpdaterOrValue);
    }, [
        initialDefaultTitle
    ]);
    return {
        title: userTitle || defaultTitle,
        setDefaultTitle: setDefaultTitleWithInitialTitle,
        setTitle: setTitle
    };
}
const $f47ce2e2be077c91$export$66e677fcbdac9c95 = ()=>{
    const [connectGadgets, setConnectGadgets] = (0, $eUqFw.useState)({});
    const registerConnectGadget = (0, $eUqFw.useCallback)((id, setTitle)=>{
        setConnectGadgets((gadgets)=>({
                ...gadgets,
                [id]: setTitle
            }));
    }, []);
    const unregisterConnectGadget = (0, $eUqFw.useCallback)((id)=>{
        setConnectGadgets((gadgets)=>{
            const { [id]: _, ...rest } = gadgets;
            return rest;
        });
    }, []);
    const setCustomTitle = (0, $eUqFw.useCallback)((id, title)=>{
        const setTitle = connectGadgets[id];
        if (!setTitle) throw new Error(`Unable to set custom title on Connect gadget. No gadget with id ${id} found. Available ids: ${Object.keys(connectGadgets).join(', ')}`);
        return setTitle(title);
    }, [
        connectGadgets
    ]);
    return {
        registerConnectGadget: registerConnectGadget,
        setCustomTitle: setCustomTitle,
        unregisterConnectGadget: unregisterConnectGadget
    };
};

});

parcelRegister("9wImn", function(module, exports) {

$parcel$export(module.exports, "useDashboardsWallboardSlideShow", () => $e058ecbd1ef112a2$export$ebab373c2ca6394);

var $eUqFw = parcelRequire("eUqFw");

var $01Qi5 = parcelRequire("01Qi5");

var $kJlBc = parcelRequire("kJlBc");
const $e058ecbd1ef112a2$var$nextIndex = (prevIndex, maxLength)=>(prevIndex + 1) % maxLength;
const $e058ecbd1ef112a2$var$randomiseIfApplicable = (random, data)=>{
    if (random === 'true' && data) {
        const result = [
            ...data
        ];
        result.sort(()=>Math.random() - 0.5);
        return result;
    }
    return data;
};
const $e058ecbd1ef112a2$var$DEFAULT_CYCLE_PERIOD = 30000;
const $e058ecbd1ef112a2$var$safeParseCyclePeriodOrDefault = (cyclePeriod)=>{
    try {
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        return Math.min(Number.parseInt(cyclePeriod, 10), Math.pow(2, 31) - 1);
    } catch (e) {
        return $e058ecbd1ef112a2$var$DEFAULT_CYCLE_PERIOD;
    }
};
const $e058ecbd1ef112a2$export$ebab373c2ca6394 = ()=>{
    const [cyclePeriod] = (0, $kJlBc.useQueryParam)('cyclePeriod');
    const [random] = (0, $kJlBc.useQueryParam)('random');
    const { data: data, error: error, loading: loading } = (0, $01Qi5.useMultiDashboardsResource)();
    const [dashboards, setDashboards] = (0, $eUqFw.useState)([]);
    const [currentIndex, setIndex] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useEffect)(()=>{
        if (cyclePeriod && dashboards) {
            if (dashboards.length < 2) // there is only one dashboard
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
            // start wallboard slide show
            const interval = setInterval(()=>{
                setIndex((prev)=>$e058ecbd1ef112a2$var$nextIndex(prev, dashboards.length));
            }, $e058ecbd1ef112a2$var$safeParseCyclePeriodOrDefault(cyclePeriod));
            return ()=>clearInterval(interval);
        }
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        dashboards,
        cyclePeriod
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Randomises and sets the list of dashboards for slide show on initialisation. This call should
        // only happen once unless data or random is changed e.g. a page reload or url change
        if (data && data?.length > 0) setDashboards($e058ecbd1ef112a2$var$randomiseIfApplicable(random, data));
    }, [
        data,
        random
    ]);
    // We create a new error object as the endpoint for wallboard slide show does not return any error(s)
    // if the user cannot see a dashboard. Instead, if the response data returns 0 dashboards, it indicates the user has provided
    // invalid dashboard ids and we will show an error page by instantiating a new error here
    if (data?.length === 0 && !loading) return {
        data: null,
        // "401" has been intentionally left as a string in this error message as this will cause a wallboard permission error page to render
        // It did previously utilise DASHBOARD_PERMISSION_ERROR_CODE_LIST instead, but there seems to be import issues and it is not working as expected.
        // A hardcoded string will have to do for now.
        error: new Error('No dashboards could load on wallboard: 401'),
        currentDashboardIndex: currentIndex,
        loading: loading
    };
    return {
        data: dashboards,
        currentDashboardIndex: currentIndex,
        error: error,
        loading: loading
    };
};

});

parcelRegister("aNvoT", function(module, exports) {

$parcel$export(module.exports, "WallboardColumn", () => $d2258bff85021c75$export$74305058b127e581);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6tahE = parcelRequire("6tahE");

var $4klDo = parcelRequire("4klDo");

var $7kNm4 = parcelRequire("7kNm4");
const { createRenderFunction: $d2258bff85021c75$var$createGadgetRender } = (0, $4klDo.createRendererContext)();
const $d2258bff85021c75$var$GADGET_CYCLE_PERIOD = 10000;
const $d2258bff85021c75$export$74305058b127e581 = ({ gadgets: gadgets, columnWidth: columnWidth, children: children, dashboardId: dashboardId })=>{
    const renderGadget = $d2258bff85021c75$var$createGadgetRender(children);
    const gadgetsGroups = (0, $eUqFw.useMemo)(()=>(0, $7kNm4.groupByColor)(gadgets), [
        gadgets
    ]);
    const initGadgetIndexInGroup = (0, $eUqFw.useMemo)(()=>gadgetsGroups.map(()=>0), [
        gadgetsGroups
    ]);
    const [currGadgetIndexInGroup, setCurrentGadgetIndexInGroup] = (0, $eUqFw.useState)(initGadgetIndexInGroup);
    (0, $eUqFw.useEffect)(()=>{
        // If the dashboardId has changed (i.e. we're on slide show), we reset the index of the column
        setCurrentGadgetIndexInGroup(initGadgetIndexInGroup);
    }, [
        dashboardId,
        initGadgetIndexInGroup
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // We don't cycle through gadgets if there is 1 or less
        if (gadgets.length < 2) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const interval = setInterval(()=>{
            setCurrentGadgetIndexInGroup((prevIndexArray)=>prevIndexArray.map((prevIndex, groupIndex)=>(prevIndex + 1) % gadgetsGroups[groupIndex].length));
        }, $d2258bff85021c75$var$GADGET_CYCLE_PERIOD);
        return ()=>clearInterval(interval);
    }, [
        gadgets.length,
        gadgetsGroups
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), {
        medium: columnWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2258bff85021c75$var$ColumnWrapper, null, gadgetsGroups.map((gadgetsGroup, groupIndex)=>gadgetsGroup.map((gadget, gadgetIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2258bff85021c75$var$WallboardGadgetWrapper, {
                key: gadget.id,
                isHidden: currGadgetIndexInGroup[groupIndex] !== gadgetIndex,
                row: groupIndex + 1
            }, renderGadget({
                gadget: gadget
            }))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2258bff85021c75$var$WallboardGadgetWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { row: row, isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rm6yep": (0, $9t7rW.default)(__cmplp.row)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_v5641pn7 _p3z3u4gj _1461kb7n _4t3i1osq _1bsb1osq",
            __cmplp.isHidden ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $d2258bff85021c75$var$ColumnWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _yv0ei47z",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7kNm4", function(module, exports) {

$parcel$export(module.exports, "groupByColor", () => $10032c8cc1d51ade$export$68f58c2102b7f5d6);
const $10032c8cc1d51ade$export$68f58c2102b7f5d6 = (gadgets)=>{
    const map = new Map();
    gadgets.forEach((gadget)=>{
        const { color: color } = gadget;
        const collection = map.get(color);
        if (!collection) map.set(color, [
            gadget
        ]);
        else collection.push(gadget);
    });
    return Array.from(map.values());
};

});


parcelRegister("hg1IN", function(module, exports) {

$parcel$export(module.exports, "WallboardGadget", () => $3800cd73ba3781bb$export$b6a7febb99998bac);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $1Z7MZ = parcelRequire("1Z7MZ");
var $dpbXU = parcelRequire("dpbXU");
var $7G1NC = parcelRequire("7G1NC");
var $7dAFN = parcelRequire("7dAFN");
var $ipYDU = parcelRequire("ipYDU");
var $9TJyz = parcelRequire("9TJyz");

var $hnl0Q = parcelRequire("hnl0Q");
const $3800cd73ba3781bb$var$noop = ()=>undefined;
const $3800cd73ba3781bb$export$b6a7febb99998bac = ({ gadget: gadget, dashboardId: dashboardId, refreshId: refreshId, unconfiguredFallback: unconfiguredFallback, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnRegisterConnectGadget })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9TJyz.GadgetReadOnlyController), {
        display: "normal",
        dashboardRefreshId: refreshId,
        data: gadget
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7G1NC.GadgetControllerContextConsumer), null, ({ isMaximized: isMaximized, shouldUseCache: shouldUseCache, isLoading: isLoading, setIsLoading: setIsLoading, isUnconfigured: isUnconfigured, setDefaultTitle: setDefaultTitle, title: title, onRenameSave: onRenameSave })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnl0Q.Header), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpbXU.GadgetBoundary), {
            data: gadget,
            isError: !gadget.title,
            errorFallback: gadget.errorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallbackBase), {
                id: gadget.id,
                message: gadget.errorMessage
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
                id: gadget.id,
                errorType: !gadget.title ? (0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR : (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Z7MZ.GadgetAnalyticsContainer), {
            data: gadget
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipYDU.GadgetInner), {
            dashboardId: dashboardId,
            data: gadget,
            isUnconfigured: isUnconfigured,
            isEditModeEnabled: false,
            isLoading: isLoading,
            isInEditMode: false,
            shouldUseCache: shouldUseCache,
            setIsLoading: setIsLoading,
            setDefaultTitle: setDefaultTitle,
            onEditModeCancel: $3800cd73ba3781bb$var$noop,
            isMaximized: isMaximized,
            unconfiguredFallback: unconfiguredFallback,
            onRegisterConnectGadget: onRegisterConnectGadget,
            onUnregisterConnectGadget: onUnRegisterConnectGadget,
            setTitle: onRenameSave
        }))))));

});
parcelRegister("1Z7MZ", function(module, exports) {

$parcel$export(module.exports, "GadgetAnalyticsContainer", () => $1984d96c6049397e$export$33d5cbc3e6507749);

var $eUqFw = parcelRequire("eUqFw");

var $dYru8 = parcelRequire("dYru8");

var $QPCBp = parcelRequire("QPCBp");
const $1984d96c6049397e$export$33250e472f9e12c2 = 4840;
const $1984d96c6049397e$export$33d5cbc3e6507749 = ({ data: data, children: children })=>{
    const fireAnalytics = (0, $dYru8.useDashboardAnalytics)();
    const eventSent = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (data !== null && eventSent.current === false) {
            fireAnalytics({
                ...(0, $QPCBp.getGadgetAnalyticsProps)(data),
                action: 'viewed'
            });
            eventSent.current = true;
        }
    }, [
        data,
        fireAnalytics
    ]);
    if (!data) return null;
    if (data.renderedGadgetUrl != null && data.renderedGadgetUrl.length > $1984d96c6049397e$export$33250e472f9e12c2) {
        if (eventSent.current === false) {
            fireAnalytics({
                ...(0, $QPCBp.getGadgetAnalyticsProps)(data),
                action: 'viewedFailed'
            });
            eventSent.current = true;
        }
        throw new Error('Request header is too large');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});
parcelRegister("QPCBp", function(module, exports) {

$parcel$export(module.exports, "getGadgetAnalyticsProps", () => $46850f109fd87be9$export$42d88d3ece4aff0);


var $iFHrw = parcelRequire("iFHrw");
const $46850f109fd87be9$export$42d88d3ece4aff0 = (data)=>{
    let gadgetType = 'UNKNOWN_GADGET';
    if (data.amdModule != null) gadgetType = data.amdModule;
    else if (data.forge != null) gadgetType = data.forge.key;
    else if ((0, $iFHrw.isReactKey)(data.reactKey)) gadgetType = data.reactKey;
    return {
        eventType: (0, $41ea3621645e2acc$export$947dac6c72b26f81),
        actionSubjectId: 'gadget',
        actionSubject: 'gadget',
        attributes: {
            gadgetTitle: data.title,
            gadgetType: gadgetType
        }
    };
};

});


parcelRegister("dpbXU", function(module, exports) {

$parcel$export(module.exports, "GadgetBoundary", () => $dc6a18a2aa7ca723$export$9327e9e817f0323d);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $1KK5n = parcelRequire("1KK5n");

var $179bk = parcelRequire("179bk");

var $7G1NC = parcelRequire("7G1NC");
const $dc6a18a2aa7ca723$export$9327e9e817f0323d = ({ data: data, errorFallback: errorFallback, customPlaceholder: customPlaceholder, isError: isError, children: children })=>{
    const { id: id } = data;
    const renderKey = (0, $7G1NC.useGadgetRenderKey)();
    const shouldRender = (0, $179bk.useShouldRenderGadget)(id);
    const renderFallback = (0, $eUqFw.useCallback)(()=>errorFallback, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "gadget-content",
        packageName: "jiraDashboardInternalCommon",
        fallback: renderFallback
    }, (()=>{
        if (isError) return errorFallback;
        if (customPlaceholder) return customPlaceholder;
        if (!shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
            customHeight: `${(0, $kEBPk.GADGET_DEFAULT_HEIGHT)}px`,
            isPulsing: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: renderKey
        }, children);
    })());
};

});
parcelRegister("1KK5n", function(module, exports) {

$parcel$export(module.exports, "SkeletonGadgetContent", () => $95ec7e6a3cd0d458$export$8609a145e570faa1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4Vj1N = parcelRequire("4Vj1N");

var $aYtGv = parcelRequire("aYtGv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $84CBi = parcelRequire("84CBi");

var $5lv3X = parcelRequire("5lv3X");

var $i5ZMe = parcelRequire("i5ZMe");
const $95ec7e6a3cd0d458$export$8609a145e570faa1 = ({ dashboardId: dashboardId, gadgetId: gadgetId, customHeight: customHeight, isPulsing: isPulsing = true, isLimitedToScreenHeight: isLimitedToScreenHeight = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const gadgetLocalHeight = customHeight ?? `${(0, $5lv3X.getLocalStorageHeight)(dashboardId, gadgetId)}px`;
    const heightIsZero = gadgetLocalHeight.match(/^0[^.0-9]*$/);
    // will match 0px,0%,etc but not 0.1px
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "skeleton-gadget-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95ec7e6a3cd0d458$var$SkeletonContent, {
        height: gadgetLocalHeight,
        isLimitedToScreenHeight: isLimitedToScreenHeight,
        isPulsing: isPulsing,
        "data-testid": "dashboard-internal-common.common.gadget.gadget-skeleton.skeleton-content",
        role: "status",
        "aria-label": "Loading"
    }, !heightIsZero && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Vj1N))), {
        size: "large",
        label: formatMessage((0, $i5ZMe.default).genericPlaceholderIcon)
    })));
};
const $95ec7e6a3cd0d458$var$PulseAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95ec7e6a3cd0d458$var$SkeletonContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLimitedToScreenHeight: isLimitedToScreenHeight, isPulsing: isPulsing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kmmpls": (0, $9t7rW.default)(__cmplp.height ?? '100%'),
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i101j _bfhk1s4m _2rko1y44 _1e0c1txw _4cvr1h6o _1bah1h6o _1nj11i4r _v4q31yy8 _nhwa12c5 _1qzz10vm _8em7p3kn",
            __cmplp.isLimitedToScreenHeight && "_c71lve9e",
            __cmplp.isPulsing ? "_h82i9cwz" : "_h82iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Vj1N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $395b3ede324b6a3f$var$_react = $395b3ede324b6a3f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $395b3ede324b6a3f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $395b3ede324b6a3f$var$MediaServicesPresentationIcon = (props)=>/*#__PURE__*/ $395b3ede324b6a3f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="4" y="4" width="16" height="16" rx="2"/><rect fill="inherit" x="8" y="12" width="2" height="3" rx="1"/><rect fill="inherit" x="11" y="10" width="2" height="5" rx="1"/><rect fill="inherit" x="14" y="8" width="2" height="7" rx="1"/></g></svg>`
    }, props));
$395b3ede324b6a3f$var$MediaServicesPresentationIcon.displayName = 'MediaServicesPresentationIcon';
var $395b3ede324b6a3f$var$_default = $395b3ede324b6a3f$var$MediaServicesPresentationIcon;
module.exports.default = $395b3ede324b6a3f$var$_default;

});

parcelRegister("i5ZMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3622f593cb3455$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cb3622f593cb3455$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    genericPlaceholderIcon: {
        "id": "dashboard-internal-common.common.gadget.gadget-skeleton.generic-placeholder-icon",
        "defaultMessage": "Placeholder icon"
    }
});

});


parcelRegister("7G1NC", function(module, exports) {

$parcel$export(module.exports, "GadgetControllerContextProvider", () => $e9a64807d919c35f$export$4de1bad6b03d7763);
$parcel$export(module.exports, "GadgetControllerContextConsumer", () => $e9a64807d919c35f$export$4d4eb85e0f24da5c);
$parcel$export(module.exports, "useGadgetRefresh", () => $e9a64807d919c35f$export$9e5c8ef16417c38e);
$parcel$export(module.exports, "useGadgetRenderKey", () => $e9a64807d919c35f$export$b4c09774e3d2cd2d);
$parcel$export(module.exports, "useIsConnectDisabled", () => $e9a64807d919c35f$export$2afbda65cda4cd52);
$parcel$export(module.exports, "useGadgetSetPreferences", () => $e9a64807d919c35f$export$263d54a76be27f46);

var $4klDo = parcelRequire("4klDo");
const { createUseContextField: $e9a64807d919c35f$export$56fb4dd71461f98e, Provider: $e9a64807d919c35f$export$4de1bad6b03d7763, Consumer: $e9a64807d919c35f$export$4d4eb85e0f24da5c } = (0, $4klDo.createRendererContext)();
const $e9a64807d919c35f$export$9e5c8ef16417c38e = $e9a64807d919c35f$export$56fb4dd71461f98e('onRefresh');
const $e9a64807d919c35f$export$b4c09774e3d2cd2d = $e9a64807d919c35f$export$56fb4dd71461f98e('renderKey');
const $e9a64807d919c35f$export$2afbda65cda4cd52 = $e9a64807d919c35f$export$56fb4dd71461f98e('isConnectDisabled');
const $e9a64807d919c35f$export$263d54a76be27f46 = $e9a64807d919c35f$export$56fb4dd71461f98e('setPreferences');

});


parcelRegister("7dAFN", function(module, exports) {

$parcel$export(module.exports, "GadgetErrorFallbackBase", () => $e782b2f063635ee6$export$f9edce43cd0e391a);
$parcel$export(module.exports, "GadgetErrorFallback", () => $e782b2f063635ee6$export$6de1d4202af2589f);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7G1NC = parcelRequire("7G1NC");

var $9ocry = parcelRequire("9ocry");

var $9awI2 = parcelRequire("9awI2");

var $fg8Mt = parcelRequire("fg8Mt");
const $e782b2f063635ee6$export$f9edce43cd0e391a = ({ id: id, message: message, height: height, isRefresh: isRefresh = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onRefreshClick = (0, $7G1NC.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ocry.GadgetFallback), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: formatMessage((0, $9awI2.default).errorTitle),
            primaryColor: `var(--ds-text-warning, ${(0, $PdmhA).Y300})`
        }),
        action: isRefresh && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "default",
            spacing: "default",
            onClick: onRefreshClick
        }, formatMessage((0, $9awI2.default).refreshButtonText)),
        height: height
    }, message);
};
const $e782b2f063635ee6$export$6de1d4202af2589f = ({ id: id, errorType: errorType, height: height })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e782b2f063635ee6$export$f9edce43cd0e391a, {
        message: formatMessage((0, $fg8Mt.MESSAGES_BY_ERROR)[errorType]),
        isRefresh: (0, $fg8Mt.IS_REFRESH_BY_ERROR)[errorType],
        id: id,
        height: height
    });
};

});
parcelRegister("9ocry", function(module, exports) {

$parcel$export(module.exports, "GadgetFallback", () => $c07bff5687e4288b$export$5c6c3d588eda4d74);

var $eUqFw = parcelRequire("eUqFw");

var $179bk = parcelRequire("179bk");

var $l0teO = parcelRequire("l0teO");
const $c07bff5687e4288b$export$5c6c3d588eda4d74 = ({ icon: icon, action: action, id: id, height: height, children: children })=>{
    const ref = (0, $eUqFw.useRef)(null);
    const onGadgetRender = (0, $179bk.useOnGadgetRender)(id);
    (0, $eUqFw.useEffect)(()=>{
        const measuredHeight = ref.current?.getBoundingClientRect().height;
        onGadgetRender(measuredHeight === 0 ? undefined : measuredHeight);
    }, [
        onGadgetRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l0teO.Wrapper), {
        height: height,
        ref: ref
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l0teO.Content), null, children), action);
};

});
parcelRegister("l0teO", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $6464c2e1fd72a3e4$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Content", () => $6464c2e1fd72a3e4$export$7c6e2c02157bb7d2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $6464c2e1fd72a3e4$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _bfhk10p6 _2rkoiti9 _1e0c1txw _1n261g80 _1bah1h6o _ae4v1h6o _syazhoca _vchhusvi _y3gn1h6o _shj5idpf _123ridpf _ofypidpf _5znwidpf _1gbkidpf _w03xidpf _156oidpf _szd0idpf _12qm1osq _1tm71osq _1jpw1osq _1pol1osq",
            __cmplp.height && "_4t3it1jn",
            __cmplp.className
        ])
    });
});
const $6464c2e1fd72a3e4$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _k48pni7l _syazhoca _18s81bpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9awI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9551435eebfcd333$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9551435eebfcd333$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-message",
        "defaultMessage": "We're having some trouble displaying this gadget. It's probably a temporary problem. Try refreshing the gadget."
    },
    errorTitle: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-title",
        "defaultMessage": "Warning"
    },
    configErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.config-error-message",
        "defaultMessage": "Something went wrong. We could not save your gadget configuration. Refresh this gadget to update its configuration and try again."
    },
    refreshButtonText: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.refresh-button-text",
        "defaultMessage": "Refresh"
    },
    notSupportedErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.not-supported-error-message",
        "defaultMessage": "This gadget is no longer supported by Jira."
    }
});

});

parcelRegister("fg8Mt", function(module, exports) {

$parcel$export(module.exports, "MESSAGES_BY_ERROR", () => $e6393f5567278778$export$8c49a4613a61ecc1);
$parcel$export(module.exports, "IS_REFRESH_BY_ERROR", () => $e6393f5567278778$export$1b18ce488a22b856);

var $kEBPk = parcelRequire("kEBPk");

var $9awI2 = parcelRequire("9awI2");
const $e6393f5567278778$export$8c49a4613a61ecc1 = {
    [(0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR]: (0, $9awI2.default).configErrorMessage,
    [(0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR]: (0, $9awI2.default).errorMessage,
    [(0, $kEBPk.GADGET_ERROR_TYPE).EDIT_ERROR]: (0, $9awI2.default).errorMessage,
    [(0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: (0, $9awI2.default).notSupportedErrorMessage
};
const $e6393f5567278778$export$1b18ce488a22b856 = {
    [(0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR]: true,
    [(0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR]: true,
    [(0, $kEBPk.GADGET_ERROR_TYPE).EDIT_ERROR]: true,
    [(0, $kEBPk.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: false
};

});


parcelRegister("ipYDU", function(module, exports) {

$parcel$export(module.exports, "GadgetInner", () => $53cfe0ee600dd1ae$export$9bb8ef6d23720658);

var $eUqFw = parcelRequire("eUqFw");

var $iFHrw = parcelRequire("iFHrw");

var $179bk = parcelRequire("179bk");

var $179bk = parcelRequire("179bk");

var $cKLT4 = parcelRequire("cKLT4");

var $12Fqt = parcelRequire("12Fqt");

var $97R6n = parcelRequire("97R6n");

var $4CV7l = parcelRequire("4CV7l");

var $5McEu = parcelRequire("5McEu");

var $hBMAw = parcelRequire("hBMAw");

var $8Xm0B = parcelRequire("8Xm0B");
const $53cfe0ee600dd1ae$export$9bb8ef6d23720658 = ({ dashboardId: dashboardId, data: data, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, setTitle: setTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel, unconfiguredFallback: unconfiguredFallback, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
    const enhancedContext = (0, $cKLT4.useGadgetDataContextEnhancer)(data.context);
    const onGadgetRender = (0, $179bk.useOnGadgetRender)(data.id);
    const unconfiguredModernGadgetInViewMode = !isInEditMode && isUnconfigured && !(0, $12Fqt.isConnectGadget)(data);
    const localStorageHeight = (0, $179bk.useLocalStorageGadgetHeight)(data.id);
    if (unconfiguredFallback != null && unconfiguredModernGadgetInViewMode) return unconfiguredFallback;
    if ((0, $12Fqt.isConnectGadget)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CV7l.Connect), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        onEditModeCancel: onEditModeCancel,
        onRegister: onRegisterConnectGadget,
        onUnregister: onUnregisterConnectGadget,
        setTitle: setTitle
    });
    if (data.amdModule != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97R6n.Amd), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        amdModule: data.amdModule,
        context: enhancedContext,
        defaultTitle: data.title,
        userPrefs: data.userPrefs,
        inlineHtml: data.inlineHtml,
        isEditable: isEditModeEnabled,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        setDefaultTitle: setDefaultTitle,
        shouldUseCache: shouldUseCache,
        isMaximized: isMaximized,
        onEditModeCancel: onEditModeCancel
    });
    if (data.inlineHtml != null && data.renderedGadgetUrl == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hBMAw.InlineHtml), {
        id: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    });
    if (data.forge != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5McEu.Forge), {
        forgeKey: data.forge.key,
        gadgetData: data,
        isInEditMode: isInEditMode,
        onEditModeCancel: onEditModeCancel,
        setIsLoading: setIsLoading
    });
    if ((0, $iFHrw.isReactKey)(data.reactKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Xm0B.ReactGadget), {
        id: data.id,
        reactKey: data.reactKey,
        onEditModeCancel: onEditModeCancel,
        isInEditMode: isInEditMode,
        userPrefs: data.userPrefs,
        onRenderComplete: onGadgetRender,
        setDefaultTitle: setDefaultTitle,
        customSkeletonHeightInPx: localStorageHeight
    });
    throw new Error(`Unrecognised gadget type [${data.title}, ${data?.gadgetSpecUrl}]`);
};

});
parcelRegister("cKLT4", function(module, exports) {

$parcel$export(module.exports, "useGadgetDataContextEnhancer", () => $b00ae424e1a02e9e$export$c9b763726c221f0f);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");
var $7MyOX = parcelRequire("7MyOX");
const $b00ae424e1a02e9e$export$191677f0ab656833 = ({ user: user, ...context }, enhancedUser)=>({
        ...context,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        user: {
            ...user,
            ...enhancedUser
        }
    });
const $b00ae424e1a02e9e$export$c9b763726c221f0f = (data)=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const languageTag = (0, $7MyOX.useLanguageTag)();
    return (0, $eUqFw.useMemo)(()=>$b00ae424e1a02e9e$export$191677f0ab656833(data, {
            accountId: accountId,
            languageTag: languageTag
        }), [
        accountId,
        data,
        languageTag
    ]);
};

});
parcelRegister("7MyOX", function(module, exports) {

$parcel$export(module.exports, "useLanguageTag", () => $7b26ee60dfecfd20$export$dbb9c2c3f6b09f02);

var $gd0Sp = parcelRequire("gd0Sp");
const $7b26ee60dfecfd20$export$271af7ea6b55125e = 'en-US';
const $7b26ee60dfecfd20$export$dbb9c2c3f6b09f02 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.languageTag || $7b26ee60dfecfd20$export$271af7ea6b55125e;
};

});


parcelRegister("12Fqt", function(module, exports) {

$parcel$export(module.exports, "isConnectGadget", () => $8fd6c3e19b737ed1$export$d4464474d72c938d);

var $kEBPk = parcelRequire("kEBPk");
const $8fd6c3e19b737ed1$export$d4464474d72c938d = ({ amdModule: amdModule })=>amdModule === (0, $kEBPk.CONNECT_ITEM_AMD_MODULE);

});

parcelRegister("97R6n", function(module, exports) {

$parcel$export(module.exports, "Amd", () => $5db1bb2b57d8ad42$export$f7e1ea694836dc0c);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $crAWe = parcelRequire("crAWe");

var $guiFP = parcelRequire("guiFP");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");

var $7dAFN = parcelRequire("7dAFN");
var $1KK5n = parcelRequire("1KK5n");

var $3R3Dp = parcelRequire("3R3Dp");

var $7G1NC = parcelRequire("7G1NC");

var $dudVJ = parcelRequire("dudVJ");

var $4rWxC = parcelRequire("4rWxC");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $7pi21 = parcelRequire("7pi21");

var $26jnP = parcelRequire("26jnP");
const $5db1bb2b57d8ad42$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.VIEW_WRM_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $5db1bb2b57d8ad42$var$reportError = (gadgetId, reportGadgetMetrics, error)=>{
    reportGadgetMetrics(gadgetId, (0, $kF6iw.GADGET_START_EVENT), 'ErrorMessage');
    reportGadgetMetrics(gadgetId, (0, $kF6iw.GADGET_RENDERING_FINISHED_EVENT), 'ErrorMessage');
    (0, $9lmTX.default)({
        ...$5db1bb2b57d8ad42$var$expAttributes,
        wasExperienceSuccesful: false
    });
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: (0, $kEBPk.VIEW_WRM_GADGET_EXPERIENCE),
            packageName: 'jiraDashboardInternalCommon'
        }
    });
};
const $5db1bb2b57d8ad42$export$f7e1ea694836dc0c = ({ dashboardId: dashboardId, gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, userPrefs: userPrefs, inlineHtml: inlineHtml, isEditable: isEditable, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel })=>{
    const [{ currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { loading: loadingB, data: data } = (0, $01Qi5.useDashboardAMDModulesResource)();
    const { amdModules: amdModules = null } = data ?? {};
    const setPreferences = (0, $7G1NC.useGadgetSetPreferences)();
    const preference = (0, $eUqFw.useMemo)(()=>(0, $crAWe.decodeUserPreferences)(userPrefs?.fields), [
        userPrefs?.fields
    ]);
    const module = (0, $eUqFw.useRef)(null);
    const divRef = (0, $eUqFw.useRef)(null);
    const { addEventHandler: addEventHandler, triggerEvent: triggerEvent, removeEventHandlers: removeEventHandlers } = (0, $3R3Dp.useEventPublisher)();
    const isGlobalsReady = (0, $dudVJ.useIsGlobalsReady)();
    const isRenderable = isGlobalsReady && !loadingB && amdModules?.[amdModule ?? ''] != null || module.current != null;
    const isSkeleton = isLoading && !isInEditMode;
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $iKzwQ.useMessageBus)();
    const [gadgetError, setGadgetError] = (0, $eUqFw.useState)(null);
    (0, $4rWxC.useLinkInterceptor)(divRef.current, isLoading);
    const reportGadgetMetrics = (0, $eUqFw.useCallback)((gid, eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $kEBPk.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $kF6iw.WRM_GADGET_METRICS)
        }, {
            gadgetId: gid,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        currentPageId
    ]);
    const gadgetApi = (0, $eUqFw.useMemo)(()=>(0, $7pi21.getInlineGadgetApi)({
            gadgetId: gadgetId,
            amdModule: amdModule ?? '',
            context: context,
            defaultTitle: defaultTitle,
            isEditable: isEditable,
            closeEdit: onEditModeCancel,
            setIsLoading: setIsLoading,
            ref: divRef,
            setDefaultTitle: setDefaultTitle,
            reportGadgetMetrics: reportGadgetMetrics,
            dashboardId: dashboardId,
            addEventHandler: addEventHandler,
            removeEventHandlers: removeEventHandlers,
            triggerEvent: triggerEvent,
            setPreferences: setPreferences,
            shouldUseCache: shouldUseCache,
            view: isMaximized ? 'canvas' : 'default',
            setError: setGadgetError
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // IMPORTANT - this effect must come before AMD initialisation effect
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (inlineHtml == null || divRef.current == null) return;
        divRef.current.innerHTML = '';
        divRef.current.appendChild(document.createRange().createContextualFragment(inlineHtml));
    }, [
        inlineHtml
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (async ()=>{
            // TODO - amdModule missing should be a hard error not a type refinement
            if (!isRenderable || amdModule == null) return;
            // first time initialisation
            if (module.current == null) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const Module = amdModules[amdModule];
                try {
                    module.current = new Module(gadgetApi);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $5db1bb2b57d8ad42$var$reportError(gadgetId, reportGadgetMetrics, error);
                    setGadgetError((0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR);
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Failed to instantiate AMD module [${amdModule}]`, error);
                }
            }
            // re-render on edit-mode config/view change
            if (module.current != null) {
                (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] in ${isInEditMode ? 'Edit' : 'View'} mode`);
                reportGadgetMetrics(gadgetId, (0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT), isInEditMode ? 'Config' : 'View', undefined, undefined);
                const render = isInEditMode && module.current?.renderEdit || preference.isConfigured && module.current?.render || null;
                if (render == null) {
                    $5db1bb2b57d8ad42$var$reportError(gadgetId, reportGadgetMetrics, new Error('gadget render is null'));
                    setGadgetError((0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR);
                    // NOTE - this is not a plausible case but log it anyway, ideally we'd want type guarantees
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method missing`);
                } else {
                    try {
                        render.call(module.current, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        window.jQuery(divRef.current), preference);
                        setGadgetError(null);
                        (0, $9lmTX.default)({
                            ...$5db1bb2b57d8ad42$var$expAttributes,
                            wasExperienceSuccesful: true
                        });
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        $5db1bb2b57d8ad42$var$reportError(gadgetId, reportGadgetMetrics, error);
                        setGadgetError((0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR);
                        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method throws error`, error);
                    }
                    triggerEvent('afterRender');
                }
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInEditMode,
        preference,
        isRenderable
    ]);
    (0, $eUqFw.useEffect)(// clean up, in separate hook because we only want it called once on unmount
    ()=>()=>{
            if (module.current) module.current = null;
        }, []);
    return gadgetError != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
        errorType: gadgetError,
        id: gadgetId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26jnP.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26jnP.GadgetContainer), {
        id: `gadget-${gadgetId}`,
        ref: divRef,
        isHidden: isSkeleton
    }), isSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26jnP.SkeletonWrapper), {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.amd.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};

});
parcelRegister("3R3Dp", function(module, exports) {

$parcel$export(module.exports, "useEventPublisher", () => $0b8612fce7c28e08$export$15f587a36eadd076);

var $eUqFw = parcelRequire("eUqFw");
const $0b8612fce7c28e08$export$15f587a36eadd076 = ()=>{
    // Do not reassign current, as this change will not be seen by useCallback dependency list.  Mutate object instead.
    const eventHandlers = (0, $eUqFw.useRef)(new Map()).current;
    const singleUseEventHandlers = (0, $eUqFw.useRef)(new Map()).current;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const addEventHandler = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler, isSingleUse = false)=>{
        const handlers = isSingleUse ? singleUseEventHandlers : eventHandlers;
        handlers.has(eventName) ? handlers.get(eventName)?.add(handler) : handlers.set(eventName, new Set([
            handler
        ]));
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const removeEventHandlers = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler)=>{
        if (eventName == null) {
            eventHandlers.clear();
            singleUseEventHandlers.clear();
            return;
        }
        if (!handler) {
            eventHandlers.delete(eventName);
            singleUseEventHandlers.delete(eventName);
            return;
        }
        eventHandlers.get(eventName)?.delete(handler);
        singleUseEventHandlers.get(eventName)?.delete(handler);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const triggerEvent = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName)=>{
        eventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.delete(eventName);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    return {
        addEventHandler: addEventHandler,
        removeEventHandlers: removeEventHandlers,
        triggerEvent: triggerEvent
    };
};

});

parcelRegister("dudVJ", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalsReady", () => $16f47c2f72910861$export$676419e1d49cf911);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $fTc01 = parcelRequire("fTc01");

var $8Rnv5 = parcelRequire("8Rnv5");
let $16f47c2f72910861$var$pollingSingleton = null;
const $16f47c2f72910861$export$ef596e2a3bce12f6 = ()=>{
    $16f47c2f72910861$var$pollingSingleton = null;
};
class $16f47c2f72910861$var$PollingTimedOutError extends Error {
    constructor(){
        super('Timed out polling for globals');
        this.skipSentry = true;
    }
}
const $16f47c2f72910861$export$676419e1d49cf911 = ()=>{
    try {
        $16f47c2f72910861$var$pollingSingleton = $16f47c2f72910861$var$pollingSingleton ?? new (0, $fTc01.default)(100, (0, $8Rnv5.POLLING_TIMEOUT_MS), (0, $gUUjF.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('spa-apps.dashboard.common', 'error creating globals polling singleton', error);
    }
    // IMPORTANT - must evaluate readiness synchronously on the first call to avoid async delay
    const [isGlobalsReady, setIsGlobalsReady] = (0, $eUqFw.useState)(()=>$16f47c2f72910861$var$pollingSingleton?.isReady ?? false);
    const [isTimedOut, setIsTimedOut] = (0, $eUqFw.useState)(()=>$16f47c2f72910861$var$pollingSingleton?.isTimedOut ?? false);
    (0, $eUqFw.useEffect)(()=>{
        const setGlobalsReady = ()=>{
            setIsGlobalsReady(true);
        };
        const setTimedOut = ()=>{
            setIsTimedOut(true);
        };
        $16f47c2f72910861$var$pollingSingleton?.addEventListener('onReady', setGlobalsReady);
        $16f47c2f72910861$var$pollingSingleton?.addEventListener('onTimeout', setTimedOut);
        return ()=>{
            $16f47c2f72910861$var$pollingSingleton?.removeEventListener('onReady', setGlobalsReady);
            $16f47c2f72910861$var$pollingSingleton?.removeEventListener('onTimeout', setTimedOut);
        };
    }, []);
    // NOTE - additional state and effect is needed for error to trigger react ErrorBoundary
    (0, $eUqFw.useEffect)(()=>{
        if (isTimedOut) throw new $16f47c2f72910861$var$PollingTimedOutError();
    }, [
        isTimedOut
    ]);
    return $16f47c2f72910861$var$pollingSingleton !== null ? isGlobalsReady : (0, $8Rnv5.DEPENDENCIES).every((dep)=>window[dep]);
};

});
parcelRegister("fTc01", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b6a9c79541ad9f$export$2e2bcd8739ae039);

var $8Rnv5 = parcelRequire("8Rnv5");

var $kpe7r = parcelRequire("kpe7r");
const $12b6a9c79541ad9f$var$formatGlobals = (deps)=>deps.map((dep)=>`window.${dep}`).join(', ');
// IMPORTANT - EventTarget does not exist in SSR so a degenerate version is required so that it doesn't fail SSR.
// This class should not be run on SSR as it will fall back to the degenerate version.
const $12b6a9c79541ad9f$var$EventTargetUniversal = typeof EventTarget === 'undefined' ? (0, $kpe7r.default) : EventTarget;
class $12b6a9c79541ad9f$export$2e2bcd8739ae039 extends $12b6a9c79541ad9f$var$EventTargetUniversal {
    #intervalID;
    #timeoutID;
    #startTime;
    constructor(pollingMs, timeoutMs, logger){
        super();
        this.isReady = false;
        this.isTimedOut = false;
        this.missingDeps = [];
        this.#intervalID = null;
        this.#timeoutID = null;
        this.#startTime = Date.now();
        this.#constructPolling = (pollingMs, timeoutMs, logger)=>{
            this.#intervalID = setInterval(()=>{
                const newReadyDeps = (0, $8Rnv5.DEPENDENCIES).filter((dep)=>window[dep] && this.missingDeps.includes(dep));
                if (newReadyDeps.length !== 0) {
                    this.missingDeps = this.missingDeps.filter((dep)=>!newReadyDeps.includes(dep));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `globals [${$12b6a9c79541ad9f$var$formatGlobals(newReadyDeps)}] ready after ${(Date.now() - this.#startTime) / 1000}s, missing globals [${$12b6a9c79541ad9f$var$formatGlobals(this.missingDeps)}]`);
                }
                if (this.missingDeps.length === 0) {
                    this.isReady = true;
                    this.destroy();
                    this.dispatchEvent(new CustomEvent('onReady'));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$12b6a9c79541ad9f$var$formatGlobals((0, $8Rnv5.DEPENDENCIES))}] ready after ${(Date.now() - this.#startTime) / 1000}s`);
                }
            }, pollingMs);
            this.#timeoutID = setTimeout(()=>{
                this.destroy();
                if (!this.isReady) {
                    this.isTimedOut = true;
                    this.dispatchEvent(new CustomEvent('onTimeout'));
                    logger.safeErrorWithoutCustomerData('spa-apps.dashboard.common', `timed out polling globals, missing globals [${$12b6a9c79541ad9f$var$formatGlobals(this.missingDeps)}]`);
                }
            }, timeoutMs);
        };
        this.destroy = ()=>{
            if (this.#intervalID != null) {
                clearInterval(this.#intervalID);
                this.#intervalID = null;
            }
            if (this.#timeoutID != null) {
                clearTimeout(this.#timeoutID);
                this.#timeoutID = null;
            }
        };
        this.missingDeps = (0, $8Rnv5.DEPENDENCIES).filter((dep)=>!window[dep]);
        if (this.missingDeps.length === 0) {
            logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$12b6a9c79541ad9f$var$formatGlobals((0, $8Rnv5.DEPENDENCIES))}] ready on initialisation`);
            this.isReady = true;
        } else {
            logger.safeWarnWithoutCustomerData('spa-apps.dashboard.common', `missing globals [${$12b6a9c79541ad9f$var$formatGlobals(this.missingDeps)}]`);
            this.#constructPolling(pollingMs, timeoutMs, logger);
        }
    }
    #constructPolling;
}

});
parcelRegister("8Rnv5", function(module, exports) {

$parcel$export(module.exports, "DEPENDENCIES", () => $8b56a12ae8449b80$export$db362e2d293fe52e);
$parcel$export(module.exports, "POLLING_TIMEOUT_MS", () => $8b56a12ae8449b80$export$560b5415aba6175);
const $8b56a12ae8449b80$export$db362e2d293fe52e = [
    'require',
    'jQuery'
];
const $8b56a12ae8449b80$export$560b5415aba6175 = 60000;

});

parcelRegister("kpe7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $252284ee98806f92$export$2e2bcd8739ae039);
class $252284ee98806f92$export$2e2bcd8739ae039 {
    constructor(){
        throw new Error('EventTarget is not defined');
    }
}

});



parcelRegister("4rWxC", function(module, exports) {

$parcel$export(module.exports, "useLinkInterceptor", () => $2f5fc4620bf8cbb9$export$d6b75f959ce086c3);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $kJlBc = parcelRequire("kJlBc");

var $aoqW4 = parcelRequire("aoqW4");

var $kMGge = parcelRequire("kMGge");
const $2f5fc4620bf8cbb9$export$ad8ccaa587ef5e2e = 3984;
// Absolutely exclude any paths that contain the following regex
const $2f5fc4620bf8cbb9$var$EXCLUDED_PATHS = [
    /^\/rest\/(?:gadget|api)\/1\.0\//,
    /^\/plugins\/servlet\/gadgets\/ifr/
];
const $2f5fc4620bf8cbb9$var$isExcludedPath = (path)=>$2f5fc4620bf8cbb9$var$EXCLUDED_PATHS.some((regex)=>regex.test(path));
const $2f5fc4620bf8cbb9$export$d6b75f959ce086c3 = (element, isLoading)=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    (0, $eUqFw.useEffect)(()=>{
        if (isLoading) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const linkClickHandler = (event)=>{
            const anchor = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest?.('a');
            if (anchor == null || window.location.hostname !== anchor.hostname) // skip if it is not an anchor or to external link
            return;
            if (anchor.href && anchor.href.length > $2f5fc4620bf8cbb9$export$ad8ccaa587ef5e2e) {
                event.preventDefault();
                const flagConfig = {
                    key: (0, $eo17r.toFlagId)('urlTooLongWarning'),
                    type: 'error',
                    title: (0, $kMGge.default).linkInterceptorUrlTooLongTitle,
                    description: (0, $kMGge.default).linkInterceptorUrlTooLongDescription
                };
                showFlag(flagConfig);
            } else if (anchor.pathname && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            !(0, $aoqW4.clickedWithShortcutKeys)(event) && // some links from the monolith code are invalid and calls
            // event.preventDefault (e.g. popups), so we filter those out
            !event.defaultPrevented && !$2f5fc4620bf8cbb9$var$isExcludedPath(anchor.pathname)) {
                event.preventDefault();
                push(anchor.href);
            }
        };
        element?.addEventListener('click', linkClickHandler);
        return ()=>{
            element?.removeEventListener('click', linkClickHandler);
        };
    }, [
        element,
        isLoading,
        push,
        showFlag
    ]);
};

});
parcelRegister("aoqW4", function(module, exports) {

$parcel$export(module.exports, "clickedWithShortcutKeys", () => $7b45ac25e57fd492$export$141f1be6ae7df96b);
const $7b45ac25e57fd492$export$141f1be6ae7df96b = (e)=>{
    if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return true;
    return false;
};

});

parcelRegister("kMGge", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c87c7e280c79f2a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c87c7e280c79f2a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    linkInterceptorUrlTooLongTitle: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-title",
        "defaultMessage": "Requested URL too large"
    },
    linkInterceptorUrlTooLongDescription: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-description",
        "defaultMessage": "Try shortening the JQL of your saved filter."
    }
});

});


parcelRegister("7pi21", function(module, exports) {

$parcel$export(module.exports, "getInlineGadgetApi", () => $1a76c735cfb7acab$export$a7c3539038fb2c0);

var $jG2Eu = parcelRequire("jG2Eu");

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $guiFP = parcelRequire("guiFP");

var $5lv3X = parcelRequire("5lv3X");
const $1a76c735cfb7acab$export$a7c3539038fb2c0 = ({ gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, isEditable: isEditable, closeEdit: closeEdit, ref: ref, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, reportGadgetMetrics: reportGadgetMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), dashboardId: dashboardId, setPreferences: setPreferences, addEventHandler: addEventHandler, removeEventHandlers: removeEventHandlers, triggerEvent: triggerEvent, shouldUseCache: shouldUseCache, view: view, setError: setError })=>{
    const resize = ()=>{
        if (!dashboardId || !gadgetId) return;
        // Store current height of gadget in local storage
        const height = ref.current?.getBoundingClientRect().height;
        (0, $5lv3X.updateLocalStorageHeight)(dashboardId, gadgetId, height);
    };
    const moduleAPI = {
        on: (id, handler)=>addEventHandler(id, handler),
        once: (id, handler)=>addEventHandler(id, handler, true),
        off: (id, handler)=>removeEventHandlers(id, handler),
        trigger: (id)=>triggerEvent(id)
    };
    const expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, $kEBPk.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    return {
        gadget: {
            amdModule: amdModule,
            context: context,
            moduleAPI: moduleAPI
        },
        showLoadingBar: ()=>{
            setIsLoading(true);
        },
        resize: resize,
        isEditable: ()=>isEditable,
        savePreferences: async (preferences)=>{
            // IMPORTANT
            //  per JDAG-413 we need to batch react state updates with route resource update
            const maybePromise = setPreferences(preferences, ()=>{
                setError(null);
                closeEdit();
            });
            if (!maybePromise) return;
            try {
                await maybePromise;
                (0, $9lmTX.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd.api', `${e.message} [${defaultTitle}]`);
                setError((0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR);
                (0, $9lmTX.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: false
                });
                (0, $guiFP.default)({
                    error: e,
                    meta: {
                        id: (0, $kEBPk.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
                        packageName: 'jiraDashboardInternalCommon'
                    }
                });
            }
        },
        setTitle: setDefaultTitle,
        hideLoadingBar: ()=>setIsLoading(false),
        initRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        getRefreshFieldValue: (fieldName)=>{
            const input = ref.current?.querySelector(`input[name=${fieldName || 'refresh'}]`);
            if (input == null || !(input instanceof HTMLInputElement) || !input.checked) return 'false';
            return input.value;
        },
        getGadgetId: ()=>gadgetId,
        closeEdit: closeEdit,
        // deprecated
        forceLayoutRefresh: ()=>{
            (0, $gUUjF.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'deprecated forceLayoutRefresh() is called');
            resize();
        },
        publicInstace: ()=>(0, $gUUjF.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'Unexpected public instance called'),
        _preparePreferencesToBeSaved: (preference)=>{
            let preferenceStr = '';
            try {
                preferenceStr = JSON.stringify(preference);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                preferenceStr = 'non-stringifiable type';
            }
            (0, $gUUjF.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', `Unexpected prepare preferences called with ${preferenceStr} for ${defaultTitle}`);
        },
        getContext: ()=>context,
        // deprecated, replaced by react life cycle
        ...moduleAPI,
        listenTo: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        stopListening: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        listenToOnce: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        reportGadgetMetrics: reportGadgetMetrics,
        shouldUseCache: shouldUseCache,
        view: view
    };
};

});

parcelRegister("26jnP", function(module, exports) {

$parcel$export(module.exports, "styleOverrideFromMonolith", () => $fc0d182b030fb28e$export$a135452a315aaac8);
$parcel$export(module.exports, "editModeStyleOverrideFromMonolith", () => $fc0d182b030fb28e$export$5dd19c8cd0b42775);
$parcel$export(module.exports, "Container", () => $fc0d182b030fb28e$export$42a852a2b6b56249);
$parcel$export(module.exports, "SkeletonWrapper", () => $fc0d182b030fb28e$export$6069cbe61f690103);
$parcel$export(module.exports, "GadgetContainer", () => $fc0d182b030fb28e$export$3f9afbcf9557b0b4);
$parcel$export(module.exports, "ConfigureButton", () => $fc0d182b030fb28e$export$b95d78b6ea7efb0b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $fc0d182b030fb28e$export$a135452a315aaac8 = `
.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #5e6c84)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #0049b0)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #ebecf0)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #172b4d)"};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #5e6c84)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0049b0)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: 400;
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $fc0d182b030fb28e$export$5dd19c8cd0b42775 = `
form.aui .buttons-container .buttons, form.aui .submit-cancel-controls {
    text-align: end;
}
.piechart-gadget .dashboard-item-preferences-config {
    margin: -20px
}
`;
const $fc0d182b030fb28e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $fc0d182b030fb28e$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _11q7vuon",
            __cmplp.className
        ])
    });
});
const $fc0d182b030fb28e$export$3f9afbcf9557b0b4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHidden && "_3um015vq _kqsw7079",
            __cmplp.className
        ])
    });
});
const $fc0d182b030fb28e$export$b95d78b6ea7efb0b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4CV7l", function(module, exports) {

$parcel$export(module.exports, "Connect", () => $84c3d044e912aae6$export$59e6910693f047c2);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $3X4Tl = parcelRequire("3X4Tl");

var $1KK5n = parcelRequire("1KK5n");

var $179bk = parcelRequire("179bk");

var $7G1NC = parcelRequire("7G1NC");

var $6QUMT = parcelRequire("6QUMT");

var $dudVJ = parcelRequire("dudVJ");

var $5lv3X = parcelRequire("5lv3X");

var $bxyRs = parcelRequire("bxyRs");
const $84c3d044e912aae6$export$59e6910693f047c2 = ({ dashboardId: dashboardId, gadgetId: gadgetId, inlineHtml: inlineHtml, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, onEditModeCancel: onEditModeCancel, onRegister: onRegister, onUnregister: onUnregister, setTitle: setTitle })=>{
    const divRef = (0, $eUqFw.useRef)(null);
    const isGlobalsReady = (0, $dudVJ.useIsGlobalsReady)();
    const isDisabled = (0, $7G1NC.useIsConnectDisabled)();
    const forcedHeightFromState = (0, $6QUMT.useForcedHeight)(gadgetId);
    const forcedHeight = (0, $eUqFw.useMemo)(()=>forcedHeightFromState ?? (0, $5lv3X.getLocalStorageHeight)(dashboardId, gadgetId), [
        forcedHeightFromState,
        dashboardId,
        gadgetId
    ]);
    const onGadgetRender = (0, $179bk.useOnGadgetRender)(gadgetId);
    const onRefresh = (0, $7G1NC.useGadgetRefresh)();
    const showSkeleton = isLoading && !isInEditMode;
    (0, $eUqFw.useEffect)(()=>{
        // TODO - inlineHtml missing should be a hard error not a type refinement
        if (!isGlobalsReady || inlineHtml == null) return;
        (0, $3X4Tl.setupConnectJs)().then(()=>{
            const slotHtml = document.createRange().createContextualFragment(inlineHtml);
            if (divRef.current) {
                divRef.current.innerHTML = '';
                divRef.current.appendChild(slotHtml);
                setIsLoading(false);
                onGadgetRender();
            }
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.connect', 'Failed to render Connect gadget', error);
        // TODO - where is setError here, where is reportError here?? (compare with amd gadget)
        });
    }, [
        isGlobalsReady,
        inlineHtml,
        onGadgetRender,
        setIsLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onRegister(gadgetId, setTitle);
        return ()=>{
            onUnregister(gadgetId);
        };
    }, [
        gadgetId,
        setTitle,
        onRegister,
        onUnregister
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const target = divRef.current?.getElementsByTagName('iframe')[0];
        if (!target || !isInEditMode || isLoading) return;
        window.connectHost?.broadcastEvent('jira_dashboard_item_edit', {
            id: target.getAttribute('id')
        });
    }, [
        isInEditMode,
        isLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const connectEventHandler = (event)=>{
            const eventData = event.data;
            const target = divRef.current?.getElementsByTagName('iframe')[0];
            if (target == null || eventData == null || eventData.eid !== target.getAttribute('id')) return;
            if (eventData.type === 'unload') onRefresh();
            else onEditModeCancel();
        };
        window.addEventListener('message', connectEventHandler, false);
        return ()=>{
            window.removeEventListener('message', connectEventHandler);
        };
    }, [
        dashboardId,
        gadgetId,
        inlineHtml,
        isGlobalsReady,
        onRefresh,
        onEditModeCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxyRs.Container), {
        minHeight: forcedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxyRs.GadgetContainer), {
        id: `gadget-${gadgetId}`,
        "data-gadget-id": gadgetId,
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.connect",
        ref: divRef,
        isHidden: showSkeleton,
        isDisabled: isDisabled
    }), showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxyRs.SkeletonWrapper), {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};

});
parcelRegister("bxyRs", function(module, exports) {

$parcel$export(module.exports, "Container", () => $b8da857cf1d6c8ed$export$42a852a2b6b56249);
$parcel$export(module.exports, "SkeletonWrapper", () => $b8da857cf1d6c8ed$export$6069cbe61f690103);
$parcel$export(module.exports, "GadgetContainer", () => $b8da857cf1d6c8ed$export$3f9afbcf9557b0b4);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");
const $b8da857cf1d6c8ed$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minHeight: minHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l1bpbj": (0, $9t7rW.default)(`${__cmplp.minHeight}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1tkemu0a",
            __cmplp.className
        ])
    });
});
const $b8da857cf1d6c8ed$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _154iidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1sen",
            __cmplp.className
        ])
    });
});
const $b8da857cf1d6c8ed$var$GadgetContainerComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.isDisabled ? "_lcxvglyw" : "_lcxv1kw7",
            __cmplp.className
        ])
    });
});
const $b8da857cf1d6c8ed$export$3f9afbcf9557b0b4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// for monolith to identify gadget
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8da857cf1d6c8ed$var$GadgetContainerComponent, {
        className: "connect-gadget",
        ...props,
        ref: ref
    }));

});


parcelRegister("5McEu", function(module, exports) {

$parcel$export(module.exports, "Forge", () => $ab523a797b5fb20d$export$4b9c9e62f20bbcd0);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");

var $eciFw = parcelRequire("eciFw");

var $7AHA4 = parcelRequire("7AHA4");

var $cY2Xs = parcelRequire("cY2Xs");

var $70ON1 = parcelRequire("70ON1");

var $gGtKh = parcelRequire("gGtKh");

var $01Qi5 = parcelRequire("01Qi5");

var $78d1w = parcelRequire("78d1w");

var $7dAFN = parcelRequire("7dAFN");
var $1KK5n = parcelRequire("1KK5n");

var $7G1NC = parcelRequire("7G1NC");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $9496v = parcelRequire("9496v");
const $ab523a797b5fb20d$export$4b36646b2dadb9ee = ({ gadgetData: gadgetData, forgeKey: forgeKey, isInEditMode: isInEditMode, onEditModeCancel: onEditModeCancel, setIsLoading: setIsLoading })=>{
    const [{ currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const { data: dashboardData } = (0, $01Qi5.useDashboardResource)();
    const { data: forgeResourceData, loading: isDashboardForgeResourceLoading, error: resourceError } = (0, $01Qi5.useDashboardForgeResource)();
    const setPreferences = (0, $7G1NC.useGadgetSetPreferences)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $iKzwQ.useMessageBus)();
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [isUpdatePending, setIsUpdatePending] = (0, $eUqFw.useState)(false);
    const reportGadgetMetrics = (0, $eUqFw.useCallback)((eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $kEBPk.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $kF6iw.FORGE_GADGET_METRICS)
        }, {
            gadgetId: gadgetData.id,
            pageId: currentPageId
        });
    }, [
        gadgetData.id,
        broadcastMessageBusListener,
        currentPageId
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT), 'View');
    }, [
        reportGadgetMetrics
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isDashboardForgeResourceLoading) setIsLoading(false);
    }, [
        isDashboardForgeResourceLoading,
        setIsLoading
    ]);
    const onConfigurationSave = (0, $eUqFw.useCallback)((dataToSave)=>{
        (0, $eciFw.fireUiTriggerClickEvent)('dashboardGadgetEdit');
        setIsUpdatePending(true);
        return (0, $9496v.savePreferences)(gadgetData, dataToSave, setPreferences, setError, ()=>{
            setIsUpdatePending(false);
        });
    }, [
        gadgetData,
        setPreferences,
        setError,
        setIsUpdatePending
    ]);
    const dashboardId = dashboardData?.id || '';
    const extensionData = (0, $eUqFw.useMemo)(()=>({
            gadgetConfiguration: (0, $9496v.transformUserPrefsForForgeAppConsumption)(gadgetData.userPrefs?.fields),
            dashboard: {
                id: dashboardId
            },
            gadget: {
                id: gadgetData.id
            }
        }), [
        gadgetData.userPrefs?.fields,
        dashboardId,
        gadgetData.id
    ]);
    if (isDashboardForgeResourceLoading || isUpdatePending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null);
    const forgeGadget = forgeResourceData?.gadgets.find((gadget)=>gadget.id === forgeKey);
    if (resourceError || error || !forgeGadget || !dashboardId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
        errorType: error ?? (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR,
        id: gadgetData.id
    });
    return(// have to use Suspense here because AsyncDashboardGadget is lazy loaded using React.lazy()
    // which requires a Suspense further up the tree to work
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-dashboard-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null)
    }, isInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cY2Xs.AsyncDashboardGadgetEdit), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null),
        onEditModeCancel: onEditModeCancel,
        onConfigurationSave: onConfigurationSave
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cY2Xs.AsyncDashboardGadgetView), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KK5n.SkeletonGadgetContent), null)
    })));
};
const $ab523a797b5fb20d$export$4b9c9e62f20bbcd0 = (props)=>{
    const { gadgetData: { id: id }, isInEditMode: isInEditMode } = props;
    const envType = props.gadgetData.forge?.environment;
    const forgeKey = props.gadgetData.forge?.key;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7AHA4.AnalyticsWrapper), {
        attributes: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            envType: envType,
            ...forgeKey ? (0, $70ON1.parseExtensionId)(forgeKey) : {}
        },
        key: `${id}__${isInEditMode}`,
        isInEditMode: isInEditMode,
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
                errorType: (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR,
                id: id
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab523a797b5fb20d$export$4b36646b2dadb9ee, props));
};

});
parcelRegister("eciFw", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $514bc3269fa006a8$export$1798d320c6527c08);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $514bc3269fa006a8$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $514bc3269fa006a8$export$cfefb608fbbf02c9);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $hRcYT = parcelRequire("hRcYT");
const $514bc3269fa006a8$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $514bc3269fa006a8$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $514bc3269fa006a8$export$1798d320c6527c08 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).EDITED, {
        id: $514bc3269fa006a8$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $514bc3269fa006a8$export$762dee9e981de3e1 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $514bc3269fa006a8$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $514bc3269fa006a8$export$cfefb608fbbf02c9 = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $514bc3269fa006a8$var$triggerEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("7AHA4", function(module, exports) {

$parcel$export(module.exports, "AnalyticsWrapper", () => $f61e3bf2225ec876$export$63b55d605f8a2340);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $f61e3bf2225ec876$export$63b55d605f8a2340 = (props)=>{
    const { isInEditMode: isInEditMode, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        ...restProps,
        module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
        entryPoint: isInEditMode ? (0, $2Rqjr.ENTRY_POINT_EDIT) : undefined,
        shouldFireInitializedEvent: true
    });
};

});

parcelRegister("cY2Xs", function(module, exports) {

$parcel$export(module.exports, "AsyncDashboardGadgetView", () => $0b5eaac4436593a5$export$8f8b884c8f9b7f99);
$parcel$export(module.exports, "AsyncDashboardGadgetEdit", () => $0b5eaac4436593a5$export$11802f9302dce8a3);
// eslint-disable-next-line jira/restricted/react-lazy

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");
const $0b5eaac4436593a5$var$GADGET_START_EVENT = 'gadget-start';
const $0b5eaac4436593a5$var$GADGET_FINISH_EVENT = 'gadget-rendering-finished';

// We are using React.lazy() instead of react-loosley-lazy here because DashboardGadget
// renders RendererNext from the forge-ui package which uses Suspense
// and you can't mix React.Suspense with RLL
const $0b5eaac4436593a5$var$getUiKitModule = ()=>(parcelRequire("70Epf"));
const $0b5eaac4436593a5$export$d53932a75c2ba294 = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetView
        }))));
const $0b5eaac4436593a5$export$e388a2aaf41cd524 = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetEdit
        }))));

const $0b5eaac4436593a5$var$getIframeModule = ()=>(parcelRequire("95mrt"));
const $0b5eaac4436593a5$export$6e328a6d6807e3ef = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getIframeModule().then((module)=>({
            default: module.DashboardGadgetViewRenderer
        }))));
const $0b5eaac4436593a5$export$6618f34be2146a7d = (0, $1boRu.withMetrics)(/*#__PURE__*/ (0, $eUqFw.lazy)(()=>$0b5eaac4436593a5$var$getIframeModule().then((module)=>({
            default: module.DashboardGadgetEditRenderer
        }))));
const $0b5eaac4436593a5$var$useDashboardGadget = (onReportGadgetMetrics, extensionData, entryPoint)=>{
    const onInitialRender = (0, $eUqFw.useCallback)((payload)=>{
        if (payload !== undefined && payload.error == null) onReportGadgetMetrics($0b5eaac4436593a5$var$GADGET_FINISH_EVENT, 'View');
        else onReportGadgetMetrics($0b5eaac4436593a5$var$GADGET_FINISH_EVENT, 'ErrorMessage');
    }, [
        onReportGadgetMetrics
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        onReportGadgetMetrics($0b5eaac4436593a5$var$GADGET_START_EVENT, 'View');
    }, [
        onReportGadgetMetrics
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        const extraPropsUiCommon = {
            module: (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
            entryPoint: entryPoint,
            extensionData: {
                ...extensionData,
                entryPoint: entryPoint,
                type: (0, $2Rqjr.DASHBOARD_GADGET_MODULE)
            }
        };
        return {
            onInitialRender: onInitialRender,
            extraPropsUiCommon: extraPropsUiCommon
        };
    }, [
        entryPoint,
        extensionData,
        onInitialRender
    ]);
};
const $0b5eaac4436593a5$export$8f8b884c8f9b7f99 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $0b5eaac4436593a5$var$useDashboardGadget(onReportGadgetMetrics, extensionData);
    const extraPropsUiKit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUi = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    return (0, $2vJHJ.isCustomUIExtension)(props.extension) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$6e328a6d6807e3ef, {
        ...restProps,
        ...extraPropsCustomUi
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$d53932a75c2ba294, {
        ...restProps,
        ...extraPropsUiKit
    });
};
const $0b5eaac4436593a5$export$11802f9302dce8a3 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $0b5eaac4436593a5$var$useDashboardGadget(onReportGadgetMetrics, extensionData, (0, $2Rqjr.ENTRY_POINT_EDIT));
    const extraPropsUiKitEdit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUiEdit = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    return (0, $2vJHJ.isCustomUIExtension)(props.extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$6618f34be2146a7d, {
        ...restProps,
        ...extraPropsCustomUiEdit
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b5eaac4436593a5$export$e388a2aaf41cd524, {
        ...restProps,
        ...extraPropsUiKitEdit
    });
};

});
parcelRegister("70Epf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('l1vWP')
        ]);
        const value = parcelRequire('eLTtE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("l1vWP")
    ]).then(()=>parcelRequire('eLTtE'));
}

});

parcelRegister("95mrt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bEZw0')
        ]);
        const value = parcelRequire('llDsp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bEZw0")
    ]).then(()=>parcelRequire('llDsp'));
}

});


parcelRegister("9496v", function(module, exports) {

$parcel$export(module.exports, "savePreferences", () => $eca177cb92a8b8c7$export$f1786e2fa4419c16);
$parcel$export(module.exports, "transformUserPrefsForForgeAppConsumption", () => $eca177cb92a8b8c7$export$b5d9bfce42b49862);

var $9lmTX = parcelRequire("9lmTX");

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");

var $guiFP = parcelRequire("guiFP");

var $eciFw = parcelRequire("eciFw");
const $eca177cb92a8b8c7$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $kEBPk.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $eca177cb92a8b8c7$export$f1786e2fa4419c16 = async (data, preferences, setPreferences, setError, onComplete)=>{
    const { title: defaultTitle } = data;
    // the backend checks that each user pref value is valid json
    // so we need to stringify string values eg ""value""
    // this is done inside the gadget for other gadget types but
    // we need to do it here for forge
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newUserPrefs = {};
    Object.entries(preferences).forEach(([key, value])=>{
        newUserPrefs[key] = typeof value === 'string' ? JSON.stringify(value) : value;
    });
    const maybePromise = setPreferences(newUserPrefs, onComplete);
    if (!maybePromise) return;
    try {
        await maybePromise;
        setError(null);
        (0, $9lmTX.default)({
            ...$eca177cb92a8b8c7$var$expAttributes,
            wasExperienceSuccesful: true
        });
        (0, $eciFw.fireTrackEditedEvent)('dashboardGadgetEdit');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.forge', `${e.message} [${defaultTitle}]`);
        setError((0, $kEBPk.GADGET_ERROR_TYPE).CONFIG_ERROR);
        (0, $9lmTX.default)({
            ...$eca177cb92a8b8c7$var$expAttributes,
            wasExperienceSuccesful: false
        });
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: (0, $kEBPk.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
                packageName: 'jiraDashboardInternalCommon'
            }
        });
        (0, $eciFw.fireOperationalEditFailedEvent)('dashboardGadgetEdit', {
            error: e
        });
    }
};
// user prefs with a string value are encoded like "&quot;value&quot;" so we need to
// decode them for forge gadgets
const $eca177cb92a8b8c7$var$decodeQuotes = (value)=>value.replace(/(?:&quot;)/gm, '"');
const $eca177cb92a8b8c7$export$b5d9bfce42b49862 = (userPrefsFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedUserPrefs = {};
    if (userPrefsFields !== undefined) userPrefsFields.forEach((field)=>{
        if (field.name !== 'isConfigured') // the backend stringifies all configuration values,
        // we need to parse them here for forge gadgets
        transformedUserPrefs[field.name] = JSON.parse($eca177cb92a8b8c7$var$decodeQuotes(field.value));
    });
    return transformedUserPrefs;
};

});


parcelRegister("hBMAw", function(module, exports) {

$parcel$export(module.exports, "InlineHtml", () => $5cf2ed0011b76313$export$109427fbef437c1e);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1cMWl = parcelRequire("1cMWl");

var $84CBi = parcelRequire("84CBi");

var $179bk = parcelRequire("179bk");

var $4rWxC = parcelRequire("4rWxC");
const $5cf2ed0011b76313$export$109427fbef437c1e = ({ id: id, inlineHtml: inlineHtml, isLoading: isLoading, setIsLoading: setIsLoading })=>{
    const inlineHtmlRef = (0, $eUqFw.useRef)(null);
    const [hasIntroLogo, setHasIntroLogo] = (0, $eUqFw.useState)(false);
    (0, $4rWxC.useLinkInterceptor)(inlineHtmlRef.current, isLoading);
    (0, $eUqFw.useEffect)(()=>{
        const slotHtml = document.createRange().createContextualFragment(inlineHtml);
        if (inlineHtmlRef.current) {
            inlineHtmlRef.current.innerHTML = '';
            inlineHtmlRef.current.appendChild(slotHtml);
            const introLogoElement = inlineHtmlRef.current.querySelector('.intro-logo');
            if (introLogoElement) setHasIntroLogo(true);
        }
        setIsLoading(false);
    }, [
        inlineHtml,
        setIsLoading
    ]);
    (0, $179bk.useOnGadgetRenderEffect)(id, inlineHtmlRef.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "inline-html-gadget",
        hold: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: hasIntroLogo && $5cf2ed0011b76313$var$introStyles
    }, hasIntroLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cMWl.default), {
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: `gadget-${id}`,
        ref: inlineHtmlRef
    })));
};
const $5cf2ed0011b76313$var$introStyles = (0, $1ZAYh.xcss)({
    overflow: 'auto',
    height: '160px',
    display: 'flex',
    justifyContent: 'space-around',
    padding: 'space.200',
    gap: 'space.200'
});

});
parcelRegister("1cMWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f396f88c4fb6c77$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $2rJNZ = parcelRequire("2rJNZ");
const $8f396f88c4fb6c77$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2rJNZ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2rJNZ))
});
var $8f396f88c4fb6c77$export$2e2bcd8739ae039 = $8f396f88c4fb6c77$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $8f396f88c4fb6c77$export$a179c88182cb9d56 = [
    0,
    0,
    431,
    406
];

});
parcelRegister("2rJNZ", function(module, exports) {
module.exports = new URL("graph-go-up-with-people.ef1ef5d4.svg", import.meta.url).toString();

});



parcelRegister("8Xm0B", function(module, exports) {

$parcel$export(module.exports, "ReactGadget", () => $109f8595095265b5$export$561f0f8350aca3ee);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");

var $kEBPk = parcelRequire("kEBPk");

var $0cdA8 = parcelRequire("0cdA8");

var $78d1w = parcelRequire("78d1w");

var $7dAFN = parcelRequire("7dAFN");

var $7G1NC = parcelRequire("7G1NC");

var $iKzwQ = parcelRequire("iKzwQ");

var $kF6iw = parcelRequire("kF6iw");

var $rEZ85 = parcelRequire("rEZ85");
const $109f8595095265b5$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $109f8595095265b5$export$561f0f8350aca3ee = ({ id: id, userPrefs: userPrefs, isInEditMode: isInEditMode, reactKey: reactKey, onEditModeCancel: onEditModeCancel, onRenderComplete: onRenderComplete, setDefaultTitle: setDefaultTitle, customSkeletonHeightInPx: customSkeletonHeightInPx })=>{
    const [{ currentPageId: currentPageId }] = (0, $78d1w.useSpaStateTransition)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $iKzwQ.useMessageBus)();
    const setPreferences = (0, $7G1NC.useGadgetSetPreferences)();
    const ref = (0, $eUqFw.useRef)(null);
    const isExperienceCompletedRef = (0, $eUqFw.useRef)(false);
    const { state: state, componentView: ComponentView, componentEdit: ComponentEdit, setState: setState } = (0, $rEZ85.useReactGadgetState)(id, reactKey);
    const experienceKey = `${(0, $kEBPk.VIEW_REACT_GADGET_EXPERIENCE)}-${reactKey.split('/')[1]}`; // e.g. view-react-gadget-filter-results
    const reportGadgetMetrics = (0, $eUqFw.useCallback)((eventType)=>{
        broadcastMessageBusListener((0, $kEBPk.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: isInEditMode ? 'Config' : 'View',
            source: (0, $kF6iw.REACT_GADGET_METRICS)
        }, {
            gadgetId: id,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        isInEditMode,
        id,
        currentPageId
    ]);
    const reportGadgetStart = (0, $eUqFw.useCallback)(()=>{
        reportGadgetMetrics((0, $kF6iw.GADGET_START_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const onGadgetFinish = (0, $eUqFw.useCallback)(// this API is not ideal, but a temporary solution to allow gadget to not save height to localStorage
    (shouldPersistHeight = true)=>{
        if (shouldPersistHeight) {
            const height = ref.current?.getBoundingClientRect().height;
            onRenderComplete(height);
        }
        reportGadgetMetrics((0, $kF6iw.GADGET_RENDERING_FINISHED_EVENT));
        if (!isExperienceCompletedRef.current) {
            (0, $9lmTX.default)({
                ...$109f8595095265b5$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: true
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        reportGadgetMetrics,
        onRenderComplete,
        experienceKey
    ]);
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dAFN.GadgetErrorFallback), {
            id: id,
            errorType: (0, $kEBPk.GADGET_ERROR_TYPE).VIEW_ERROR
        }), [
        id
    ]);
    const sendFailExperience = (0, $eUqFw.useCallback)(()=>{
        if (!isExperienceCompletedRef.current) {
            (0, $9lmTX.default)({
                ...$109f8595095265b5$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: false
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        experienceKey
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $kF6iw.GADGET_RENDER_CONTAINER_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const setGadgetContentTitle = (0, $eUqFw.useCallback)((contentTitle)=>{
        setDefaultTitle((initialDefaultTitle)=>contentTitle ? `${initialDefaultTitle}: ${contentTitle}` : initialDefaultTitle);
    }, [
        setDefaultTitle
    ]);
    const Component = isInEditMode ? ComponentEdit : ComponentView;
    if (state instanceof Error) {
        sendFailExperience();
        throw state;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: errorFallback,
        packageName: "jiraDashboardInternalCommon",
        id: reactKey,
        teamName: "endeavour",
        onError: sendFailExperience,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref
    }, Component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        setPreferences: setPreferences,
        state: state,
        onGadgetStart: reportGadgetStart,
        onGadgetFinish: onGadgetFinish,
        userPrefs: userPrefs,
        onEditModeCancel: onEditModeCancel,
        setState: setState,
        setGadgetContentTitle: setGadgetContentTitle,
        customSkeletonHeightInPx: customSkeletonHeightInPx
    })));
};

});
parcelRegister("rEZ85", function(module, exports) {

$parcel$export(module.exports, "useReactGadgetState", () => $5289625847d5b5e4$export$8e5d1b52830d94a5);

var $eUqFw = parcelRequire("eUqFw");

var $iFHrw = parcelRequire("iFHrw");

var $01Qi5 = parcelRequire("01Qi5");

var $aNC1f = parcelRequire("aNC1f");
const $5289625847d5b5e4$export$8e5d1b52830d94a5 = (id, reactKey)=>{
    const { data: data, update: update, loading: loading, error: error } = (0, $01Qi5.useDashboardReactGadgetsResource)();
    const reactGadgetsState = data?.reactGadgetsState ?? null;
    const state = (()=>{
        if (reactGadgetsState != null && id in reactGadgetsState) return reactGadgetsState[id];
        if (loading) return null;
        if (reactGadgetsState == null) return error ?? new Error('Gadget resource not initialised');
        return new Error(`Gadget state not found in initialised resource for gadget with reactKey: "${reactKey}" and ID: "${id}"`);
    })();
    const { componentView: componentView, componentEdit: componentEdit } = (0, $iFHrw.default)[reactKey];
    const setState = (0, $eUqFw.useCallback)((setterOrValue)=>{
        if (reactGadgetsState && id in reactGadgetsState) update((0, $aNC1f.lensReactGadget)(id, setterOrValue));
    }, [
        update,
        reactGadgetsState,
        id
    ]);
    return {
        state: state,
        componentView: componentView,
        componentEdit: componentEdit,
        setState: setState
    };
};

});
parcelRegister("aNC1f", function(module, exports) {

$parcel$export(module.exports, "lensReactGadget", () => $628c79ad0e024b67$export$703ae6d6d75e47f1);
const $628c79ad0e024b67$export$bada82ca295a26d5 = (updateGadgets)=>(resource)=>resource && {
            ...resource,
            reactGadgetsState: updateGadgets(resource.reactGadgetsState)
        };
const $628c79ad0e024b67$export$703ae6d6d75e47f1 = (id, setterOrValue)=>{
    const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
    return $628c79ad0e024b67$export$bada82ca295a26d5((reactGadgetsState)=>{
        if (!reactGadgetsState || !(id in reactGadgetsState)) return reactGadgetsState;
        const prevStateOrError = reactGadgetsState[id];
        const newState = setter(prevStateOrError);
        const prevState = prevStateOrError === null || prevStateOrError instanceof Error ? {} : prevStateOrError;
        return {
            ...reactGadgetsState,
            [id]: newState === null ? null : {
                ...prevState,
                ...newState
            }
        };
    });
};

});




parcelRegister("9TJyz", function(module, exports) {

$parcel$export(module.exports, "GadgetReadOnlyController", () => $74f89702450c427e$export$ef82df624fcfbd37);

var $eUqFw = parcelRequire("eUqFw");

var $crAWe = parcelRequire("crAWe");

var $1SsGr = parcelRequire("1SsGr");

var $5H4uC = parcelRequire("5H4uC");

var $7G1NC = parcelRequire("7G1NC");
var $gnGe3 = parcelRequire("gnGe3");

var $f9d6c = parcelRequire("f9d6c");

var $ccKf7 = parcelRequire("ccKf7");
const $74f89702450c427e$export$ef82df624fcfbd37 = ({ data: { id: id, userPrefs: userPrefs, reactKey: reactKey, configurable: configurable, refreshable: isRefreshableByJira, connect: connect, forge: forge, ...data }, display: display, dashboardRefreshId: dashboardRefreshId, children: children })=>{
    const localStorageService = (0, $1SsGr.useLocalStorageService)(id);
    const { reinitialise: onGadgetKeyChange, isEditable: isReactEditable, isLoading: isReactLoading } = (0, $f9d6c.useReactGadget)(id, reactKey);
    const automaticRefreshMs = (0, $eUqFw.useMemo)(()=>{
        const { refresh: refresh } = (0, $crAWe.decodeUserPreferences)(userPrefs?.fields);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return parseInt(refresh, 10) * 60000 || null;
    }, [
        userPrefs?.fields
    ]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const readonly = (0, $ccKf7.useGadgetReadOnlyController)({
        userPrefs: userPrefs,
        configurable: isReactEditable ?? configurable,
        ...data
    });
    // Ecosystem gadgets are not supposed to re-render if they are opting out refreshing
    const ignoreGlobalDashboardRefresh = Boolean(forge?.key || connect?.addonKey) && !isRefreshableByJira;
    const { onRefresh: onRefresh, ...common } = (0, $gnGe3.useGadgetCommonController)({
        id: id,
        display: display,
        automaticRefreshMs: automaticRefreshMs,
        localStorageService: localStorageService,
        dashboardRefreshId: ignoreGlobalDashboardRefresh ? null : dashboardRefreshId,
        onGadgetKeyChange: onGadgetKeyChange
    });
    const ecosystemRefresh = (0, $5H4uC.useEcosystemRefresh)({
        id: id,
        connect: connect,
        forge: forge
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7G1NC.GadgetControllerContextProvider), {
        value: {
            ...common,
            ...readonly,
            isRenamable: false,
            isLoading: isReactLoading ?? isLoading,
            setIsLoading: reactKey ? ()=>undefined : setIsLoading,
            onRefresh: isRefreshableByJira ? onRefresh : ecosystemRefresh.onRefresh ?? onRefresh
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ecosystemRefresh.wrapperRef
    }, children));
};

});
parcelRegister("1SsGr", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageService", () => $835ff7a2933fed43$export$aae02958650bede0);

var $eUqFw = parcelRequire("eUqFw");

var $5lv3X = parcelRequire("5lv3X");
const $835ff7a2933fed43$export$d4655e9fae202a89 = (id)=>(0, $eUqFw.useCallback)((...args)=>(0, $5lv3X.getGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $835ff7a2933fed43$export$3bf5aef0d5c5f925 = (id)=>(0, $eUqFw.useCallback)((...args)=>(0, $5lv3X.putGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $835ff7a2933fed43$export$84a14851141ef231 = (id)=>(0, $eUqFw.useCallback)((...args)=>(0, $5lv3X.deleteGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $835ff7a2933fed43$export$aae02958650bede0 = (id)=>{
    const get = $835ff7a2933fed43$export$d4655e9fae202a89(id);
    const put = $835ff7a2933fed43$export$3bf5aef0d5c5f925(id);
    const del = $835ff7a2933fed43$export$84a14851141ef231(id);
    return {
        get: get,
        put: put,
        del: del
    };
};

});

parcelRegister("5H4uC", function(module, exports) {

$parcel$export(module.exports, "useEcosystemRefresh", () => $616bd816ac62015a$export$a96edb2d9dc3e9bf);

var $eUqFw = parcelRequire("eUqFw");

var $4J7Iv = parcelRequire("4J7Iv");

var $kEBPk = parcelRequire("kEBPk");
const $616bd816ac62015a$export$1da99641cec7fdf3 = (payload, id)=>window.connectHost?.broadcastEvent((0, $kEBPk.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {
        id: id
    }, payload);
const $616bd816ac62015a$export$a96edb2d9dc3e9bf = ({ id: id, connect: connect, forge: forge })=>{
    const isConnect = Boolean(connect?.addonKey);
    const isForge = Boolean(forge?.key);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const ecosystemOnRefresh = (0, $eUqFw.useCallback)(()=>{
        const payload = {
            origin: 'gadget',
            gadgetId: id
        };
        if (isConnect) $616bd816ac62015a$export$1da99641cec7fdf3(payload, wrapperRef.current?.querySelector('iframe')?.id);
        else if (isForge) (0, $4J7Iv.emit)((0, $kEBPk.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), payload);
    }, [
        id,
        isConnect,
        isForge
    ]);
    return {
        wrapperRef: wrapperRef,
        onRefresh: isConnect || isForge ? ecosystemOnRefresh : undefined
    };
};

});

parcelRegister("gnGe3", function(module, exports) {

$parcel$export(module.exports, "useGadgetCommonController", () => $d34a301803596a04$export$3db154a5767b2bd0);

var $eUqFw = parcelRequire("eUqFw");

var $kEBPk = parcelRequire("kEBPk");
const $d34a301803596a04$export$3db154a5767b2bd0 = ({ id: id, display: display, automaticRefreshMs: automaticRefreshMs, localStorageService: { get: localStorageServiceGet, put: localStorageServicePut, del: localStorageServiceDel }, dashboardRefreshId: dashboardRefreshId, onGadgetKeyChange: onGadgetKeyChange })=>{
    const isDisplayed = display !== (0, $kEBPk.GADGET_DISPLAY).HIDDEN;
    const isMaximized = display === (0, $kEBPk.GADGET_DISPLAY).MAXIMIZED;
    const [isMinimized, setIsMinimized] = (0, $eUqFw.useState)(()=>localStorageServiceGet('minimized') === 'true');
    const onMinimizeOrRestore = (0, $eUqFw.useCallback)((doMinimize)=>{
        if (doMinimize !== isMinimized) {
            if (doMinimize) localStorageServicePut('minimized', 'true');
            else localStorageServiceDel('minimized');
            setIsMinimized(doMinimize);
        }
    }, [
        isMinimized,
        setIsMinimized,
        localStorageServicePut,
        localStorageServiceDel
    ]);
    const [shouldUseCache, setShouldUseCache] = (0, $eUqFw.useState)(true);
    const [refreshId, setRefreshId] = (0, $eUqFw.useState)(Date.now());
    const renderKey = `${id}-${refreshId}-${dashboardRefreshId}-${isMaximized ? 'canvas' : 'default'}`;
    const prevRenderKey = (0, $eUqFw.useRef)(renderKey);
    const onRefresh = (0, $eUqFw.useCallback)(()=>{
        setShouldUseCache(false);
        setRefreshId(Date.now());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs <= 0) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (prevRenderKey.current !== renderKey) {
            prevRenderKey.current = renderKey;
            onGadgetKeyChange();
        }
    }, [
        renderKey,
        onGadgetKeyChange
    ]);
    // id is a timestamp
    const lastRefreshed = Math.max(Number(dashboardRefreshId), refreshId);
    return {
        isDisplayed: isDisplayed,
        isMaximized: isMaximized,
        isMinimized: isMinimized,
        onMinimizeOrRestore: onMinimizeOrRestore,
        renderKey: renderKey,
        shouldUseCache: shouldUseCache,
        onRefresh: onRefresh,
        lastRefreshed: lastRefreshed
    };
};

});

parcelRegister("f9d6c", function(module, exports) {

$parcel$export(module.exports, "useReactGadget", () => $d61a6b4d1ba2c171$export$a821269bdacf74ba);

var $eUqFw = parcelRequire("eUqFw");

var $iFHrw = parcelRequire("iFHrw");

var $01Qi5 = parcelRequire("01Qi5");

var $aNC1f = parcelRequire("aNC1f");
const $d61a6b4d1ba2c171$export$a821269bdacf74ba = (gadgetId, reactKey)=>{
    const { update: update, refresh: refresh, loading: loading } = (0, $01Qi5.useDashboardReactGadgetsResource)();
    const [resetId, setResetId] = (0, $eUqFw.useState)(null);
    const [namedState, setNamedState] = (0, $eUqFw.useState)('idle');
    const isReactGadget = (0, $iFHrw.isReactKey)(reactKey);
    const reinitialise = (0, $eUqFw.useCallback)(()=>{
        if (namedState === 'idle') {
            // IMPORTANT - Mutations to resource while loading will be lost
            if (loading) {
                setResetId(gadgetId);
                setNamedState('update');
            } else {
                // IMPORTANT - Set null in the resource and then refresh to remove the nulls
                update((0, $aNC1f.lensReactGadget)(gadgetId, null));
                setNamedState('refresh');
            }
        }
    }, [
        gadgetId,
        loading,
        update,
        namedState
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!loading && resetId != null && namedState === 'update') {
            setResetId(null);
            // IMPORTANT - Set null in the resource and then refresh to remove the nulls
            update((0, $aNC1f.lensReactGadget)(resetId, null));
            setNamedState('refresh');
        }
    }, [
        loading,
        update,
        resetId,
        namedState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // IMPORTANT - We need to arrive here asynchronously in case multiple gadgets are reset at once
        if (namedState === 'refresh') {
            setNamedState('loading');
            refresh();
        }
    }, [
        refresh,
        namedState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && namedState === 'loading') setNamedState('idle');
    }, [
        loading,
        namedState
    ]);
    if (!isReactGadget) return {
        reinitialise: ()=>undefined,
        isEditable: null,
        isLoading: null
    };
    const { componentEdit: componentEdit } = (0, $iFHrw.default)[reactKey];
    return {
        reinitialise: reinitialise,
        isEditable: Boolean(componentEdit),
        isLoading: namedState === 'loading' || loading && namedState === 'idle'
    };
};

});

parcelRegister("ccKf7", function(module, exports) {

$parcel$export(module.exports, "useGadgetReadOnlyController", () => $b5a581eaa86b718a$export$8c1c073a838c204c);

var $jG2Eu = parcelRequire("jG2Eu");

var $f9MgH = parcelRequire("f9MgH");

var $5RHEV = parcelRequire("5RHEV");
const $b5a581eaa86b718a$export$8c1c073a838c204c = ({ customisedTitle: customisedTitle, title: defaultTitle, configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
    const { isUnconfigured: isUnconfigured } = (0, $5RHEV.useConfigurationStatus)({
        configurable: configurable,
        hasNonHiddenUserPrefs: hasNonHiddenUserPrefs,
        renderedGadgetUrl: renderedGadgetUrl,
        userPrefs: userPrefs
    });
    const { title: title, setDefaultTitle: setDefaultTitle, setTitle: setTitle } = (0, $f9MgH.useGadgetTitle)({
        defaultTitle: defaultTitle,
        title: customisedTitle
    });
    return {
        isUnconfigured: isUnconfigured,
        isEditModeEnabled: false,
        isEditButtonDisabled: true,
        isInEditMode: false,
        isConnectDisabled: false,
        onEditModeTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onEditModeCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        title: title,
        isRenaming: false,
        setDefaultTitle: setDefaultTitle,
        onRenameTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onRenameSave: setTitle,
        onRenameCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setPreferences: ()=>null
    };
};

});
parcelRegister("5RHEV", function(module, exports) {

$parcel$export(module.exports, "useConfigurationStatus", () => $6ef60b3a4371683b$export$416bc2c29f65a3f8);

var $eUqFw = parcelRequire("eUqFw");

var $9hXa4 = parcelRequire("9hXa4");
const $6ef60b3a4371683b$export$416bc2c29f65a3f8 = ({ configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
    const isConfigurable = Boolean(configurable || hasNonHiddenUserPrefs || renderedGadgetUrl);
    const isUnconfigured = (0, $eUqFw.useMemo)(()=>isConfigurable && !(0, $9hXa4.isGadgetConfigured)(userPrefs), [
        isConfigurable,
        userPrefs
    ]);
    return {
        isConfigurable: isConfigurable,
        isUnconfigured: isUnconfigured
    };
};

});



parcelRegister("hnl0Q", function(module, exports) {

$parcel$export(module.exports, "Header", () => $f3dfdf7a4db80289$export$8b251419efc915eb);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f3dfdf7a4db80289$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz9llx _18s8pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cnaIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb1d28840e43cc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");
const $2cb1d28840e43cc4$var$QUIT_WALLBOARD_SHORTCUT = 'escape';
const $2cb1d28840e43cc4$var$KeyboardShortcuts = (props)=>{
    const keyMap = {
        [$2cb1d28840e43cc4$var$QUIT_WALLBOARD_SHORTCUT]: {
            callback: props.onPressedEsc
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    });
};
var $2cb1d28840e43cc4$export$2e2bcd8739ae039 = $2cb1d28840e43cc4$var$KeyboardShortcuts;

});
parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (baseUrl, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '(baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: (baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $ggKAj.createHook)($e8e091cfd61e9197$var$Store);
const $e8e091cfd61e9197$export$a0308f0e05568f25 = (0, $dYfll.createSubscriber)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});






parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("5jNIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5842c1867e9678$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fa5842c1867e9678$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitle: {
        "id": "dashboard-wallboard.page-title",
        "defaultMessage": "Dashboard Wallboard"
    }
});

});

parcelRegister("Ymajv", function(module, exports) {

$parcel$export(module.exports, "UnconfiguredGadgetWallboardFallback", () => $c6f5407b32139138$export$b02fa73162f1f163);

var $eUqFw = parcelRequire("eUqFw");

var $iw0Y6 = parcelRequire("iw0Y6");

var $PdmhA = parcelRequire("PdmhA");

var $9ocry = parcelRequire("9ocry");

var $5JgJ2 = parcelRequire("5JgJ2");

var $oCBsQ = parcelRequire("oCBsQ");
const $c6f5407b32139138$export$b02fa73162f1f163 = ({ id: id })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ocry.GadgetFallback), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: formatMessage((0, $oCBsQ.default).settingsIconLabel),
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`
        }),
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $oCBsQ.default).mainMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $oCBsQ.default).configureInstructions)));
};

});
parcelRegister("oCBsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8421927f251553b5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8421927f251553b5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mainMessage: {
        "id": "dashboard-wallboard.unconfigured-gadget-wallboard-fallback.main-message",
        "defaultMessage": "Gadget is not configured"
    },
    configureInstructions: {
        "id": "dashboard-wallboard.unconfigured-gadget-wallboard-fallback.configure-instructions",
        "defaultMessage": "A dashboard editor needs to configure the gadget in Jira."
    },
    settingsIconLabel: {
        "id": "dashboard-wallboard.unconfigured-gadget-wallboard-fallback.settings-icon-label",
        "defaultMessage": "Settings"
    }
});

});




//# sourceMappingURL=async-dashboard-wallboard.e6ac4c43.js.map
